
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bTUBB", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1wScy = parcelRequire("1wScy");


var $4xcIM = parcelRequire("4xcIM");


var $T1bCI = parcelRequire("T1bCI");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $kyKWe = parcelRequire("kyKWe");


var $6R5uz = parcelRequire("6R5uz");


var $1DWH0 = parcelRequire("1DWH0");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $dpPtd = parcelRequire("dpPtd");


var $iXCQx = parcelRequire("iXCQx");


var $7aRa9 = parcelRequire("7aRa9");


var $6ykQV = parcelRequire("6ykQV");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $2UWuP = parcelRequire("2UWuP");


var $9wGTI = parcelRequire("9wGTI");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $7XPIt = parcelRequire("7XPIt");


var $euL71 = parcelRequire("euL71");


var $3Syas = parcelRequire("3Syas");


var $5FwhF = parcelRequire("5FwhF");


var $kRW4Y = parcelRequire("kRW4Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $4vC63 = parcelRequire("4vC63");


var $1PC5x = parcelRequire("1PC5x");


var $1NBp8 = parcelRequire("1NBp8");


var $bqMNb = parcelRequire("bqMNb");


var $bHd1w = parcelRequire("bHd1w");


var $iff8m = parcelRequire("iff8m");


var $5KL6w = parcelRequire("5KL6w");


var $7QM6o = parcelRequire("7QM6o");


var $k9WFY = parcelRequire("k9WFY");


var $iVd6X = parcelRequire("iVd6X");


var $b66o6 = parcelRequire("b66o6");


var $9BVDK = parcelRequire("9BVDK");


var $6eFi0 = parcelRequire("6eFi0");




/* ExportsPLUpsell.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $bQm3c = parcelRequire("bQm3c");





var $aJv6Q = parcelRequire("aJv6Q");


var $gsZdA = parcelRequire("gsZdA");





var $gLeLL = parcelRequire("gLeLL");

const $bc86709d06784c36$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "change-edition.export-upsell.title",
        defaultMessage: "Share as public link"
    },
    text: {
        id: "change-edition.export-upsell.text",
        defaultMessage: "It\u2019s easier to make changes and keep everyone on the same page with a public link."
    }
});
const $bc86709d06784c36$var$PL_EXPORT_UPSELL_SOURCE = 'publicLinksExportUpsell';
const $bc86709d06784c36$var$LEARN_MORE_PUBLIC_LINKS_HREF = 'https://support.atlassian.com/confluence-cloud/docs/share-content-externally-with-public-links/'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bc86709d06784c36$var$ExportsPLUpsellContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_x3doia51 _p12f1178 _80om73ad",
            __cmplp.className
        ])
    });
});
const $bc86709d06784c36$export$1b71d0d95fe11f4c = ({ onClick: onClick })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldShowExportUpsell = edition === (0, $euL71.ConfluenceEdition).FREE;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldShowExportUpsell && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bc86709d06784c36$var$ExportsPLUpsellContainer, {
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gLeLL.SectionMessage), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bc86709d06784c36$var$i18n.title),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bc86709d06784c36$var$i18n.text),
        appearanceType: (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE,
        source: $bc86709d06784c36$var$PL_EXPORT_UPSELL_SOURCE,
        learnMoreLink: {
            href: $bc86709d06784c36$var$LEARN_MORE_PUBLIC_LINKS_HREF,
            onClick: onClick
        },
        targetEdition: (0, $euL71.ConfluenceEdition).STANDARD,
        onUpFlowOpen: onClick,
        withGradient: false
    })));
};
const $bc86709d06784c36$export$491057b7a63084d = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).EXTERNAL_COLLAB
})($bc86709d06784c36$export$1b71d0d95fe11f4c);



var $jmjWc = parcelRequire("jmjWc");


const $4e21594c46d184a7$export$f93bbb1d19e21c24 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ldGLK",
    name: "ExportShareAsPublicLink",
    loader: async ()=>(await (parcelRequire("bEpHb"))).ExportShareAsPublicLink
});
const $4e21594c46d184a7$export$978ddac74253162e = ({ closeDropdownMenu: closeDropdownMenu, contentId: contentId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bc86709d06784c36$export$491057b7a63084d), {
        onClick: closeDropdownMenu
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e21594c46d184a7$export$f93bbb1d19e21c24, {
        contentId: contentId,
        onClick: closeDropdownMenu
    }));



var $7zgzO = parcelRequire("7zgzO");


var $dPJCf = parcelRequire("dPJCf");


var $ge2sX = parcelRequire("ge2sX");


var $f0NfR = parcelRequire("f0NfR");


var $hFGQl = parcelRequire("hFGQl");


var $jBnsv = parcelRequire("jBnsv");


var $kxhju = parcelRequire("kxhju");





var $4GDP8 = parcelRequire("4GDP8");


var $78wUU = parcelRequire("78wUU");


var $cQhbe = parcelRequire("cQhbe");


var $jcM8h = parcelRequire("jcM8h");


var $2E1L5 = parcelRequire("2E1L5");


var $5yVAS = parcelRequire("5yVAS");





var $7J5Uc = parcelRequire("7J5Uc");

const $ec1e4df6a0d98d1f$export$a35b8a8c09d7df35 = (Component)=>{
    return (props)=>{
        const [{ theme: theme }, themingActions] = (0, $7J5Uc.useThemingState)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            theme: theme,
            themingActions: themingActions,
            ...props
        });
    };
};



var $gjbSq = parcelRequire("gjbSq");


var $gTyTP = parcelRequire("gTyTP");


var $BCkug = parcelRequire("BCkug");


var $cMvQV = parcelRequire("cMvQV");








var $eSUdr = parcelRequire("eSUdr");





var $j1Ss3 = parcelRequire("j1Ss3");





var $inPa6 = parcelRequire("inPa6");


var $1Zthr = parcelRequire("1Zthr");


var $k22lL = parcelRequire("k22lL");


var $2WH1B = parcelRequire("2WH1B");


var $5gFHQ = parcelRequire("5gFHQ");








var $b3j2Y = parcelRequire("b3j2Y");

















var $3eMfQ = parcelRequire("3eMfQ");

const $d360c48f6ab9e723$export$c133e27c6e67b0b2 = 'action-archive-link';
const $d360c48f6ab9e723$export$1ee3e7befe1441e1 = 'action-restore-link';
const $d360c48f6ab9e723$export$fbd5d3e319eba191 = 'contentToolsItem';
const $d360c48f6ab9e723$export$1c76cced151657ae = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
})($d360c48f6ab9e723$var$ArchivePageItemComponent);
const $d360c48f6ab9e723$var$isReactCompilerActiveV1_result = (0, $3u0dr.isReactCompilerActiveV1)();
function $d360c48f6ab9e723$var$ArchivePageItemComponent_optimized(t0) {
    const $ = (0, $frIzR.c)(19);
    let contentId;
    let props;
    let sectionItem;
    if ($[0] !== t0) {
        ({ contentId: contentId, sectionItem: sectionItem, ...props } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = props;
        $[3] = sectionItem;
    } else {
        contentId = $[1];
        props = $[2];
        sectionItem = $[3];
    }
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query ArchivePageItemShowArchiveCTAQuery($contentId:ID!){content(id:$contentId){nodes{id operations{operation targetType}}}}`;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== contentId) {
        t2 = {
            variables: {
                contentId: contentId
            }
        };
        $[5] = contentId;
        $[6] = t2;
    } else t2 = $[6];
    const { data: data, error: error, loading: loading } = (0, $j1Ss3.useQuery)(t1, t2);
    if (loading) return null;
    if (error) {
        let t3;
        if ($[7] !== error) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[7] = error;
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const isArchiveAction = sectionItem.id === $d360c48f6ab9e723$export$c133e27c6e67b0b2;
    if (isFreeEdition && isArchiveAction || (0, $5gFHQ.canUnarchivePage)(data?.content?.nodes?.[0]?.operations)) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = [
                (0, $kRW4Y.DialogsStateContainer)
            ];
            $[9] = t3;
        } else t3 = $[9];
        let t4;
        if ($[10] !== contentId || $[11] !== createAnalyticsEvent || $[12] !== edition || $[13] !== experienceTracker || $[14] !== isArchiveAction || $[15] !== isFreeEdition || $[16] !== props || $[17] !== sectionItem) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: t3
            }, (dialogs)=>{
                const onClick = ()=>{
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "clicked",
                            actionSubject: isArchiveAction ? "archiveButton" : "restoreButton",
                            actionSubjectId: isFreeEdition ? "archivePageUpsell" : null,
                            source: $d360c48f6ab9e723$export$fbd5d3e319eba191,
                            attributes: {
                                confluenceEdition: edition
                            }
                        }
                    }).fire();
                    if (isFreeEdition) dialogs.showDialog((0, $k22lL.ArchiveUpsellDialog));
                    else {
                        experienceTracker.start({
                            name: isArchiveAction ? (0, $irVI7.ARCHIVE_PAGES_EXPERIENCE) : (0, $irVI7.RESTORE_PAGES_EXPERIENCE)
                        });
                        dialogs.showDialog(isArchiveAction ? (0, $2WH1B.ArchivePagesLoader) : (0, $1Zthr.UnarchivePagesDialogLoader), {
                            contentId: contentId,
                            source: $d360c48f6ab9e723$export$fbd5d3e319eba191
                        });
                    }
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                    ...sectionItem,
                    ...props,
                    label: sectionItem.label,
                    url: undefined,
                    onClick: onClick
                });
            });
            $[10] = contentId;
            $[11] = createAnalyticsEvent;
            $[12] = edition;
            $[13] = experienceTracker;
            $[14] = isArchiveAction;
            $[15] = isFreeEdition;
            $[16] = props;
            $[17] = sectionItem;
            $[18] = t4;
        } else t4 = $[18];
        return t4;
    }
    return null;
}
function $d360c48f6ab9e723$var$ArchivePageItemComponent_unoptimized({ contentId: contentId, sectionItem: sectionItem, ...props }) {
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { data: data, error: error, loading: loading } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query ArchivePageItemShowArchiveCTAQuery($contentId:ID!){content(id:$contentId){nodes{id operations{operation targetType}}}}`, {
        variables: {
            contentId: contentId
        }
    });
    if (loading) return null;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const isArchiveAction = sectionItem.id === $d360c48f6ab9e723$export$c133e27c6e67b0b2;
    // If user is on Free edition and the current sectionItem.id is Archive,
    // display the Archive button.
    // If user is on Premium or Standard, check if the user has permissions to
    // archive/restore the page before displaying the Archive or Restore button.
    if (isFreeEdition && isArchiveAction || (0, $5gFHQ.canUnarchivePage)(data?.content?.nodes?.[0]?.operations)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>{
        const onClick = ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: isArchiveAction ? 'archiveButton' : 'restoreButton',
                    actionSubjectId: isFreeEdition ? 'archivePageUpsell' : null,
                    source: $d360c48f6ab9e723$export$fbd5d3e319eba191,
                    attributes: {
                        confluenceEdition: edition
                    }
                }
            }).fire();
            if (isFreeEdition) dialogs.showDialog((0, $k22lL.ArchiveUpsellDialog));
            else {
                // Don't need to track experience for free edition as there is no archiving experience in free
                experienceTracker.start({
                    name: isArchiveAction ? (0, $irVI7.ARCHIVE_PAGES_EXPERIENCE) : (0, $irVI7.RESTORE_PAGES_EXPERIENCE)
                });
                dialogs.showDialog(// @ts-expect-error ArchivePagesLoader & UnarchivePagesDialogLoader predate the TypeScript support here
                isArchiveAction ? (0, $2WH1B.ArchivePagesLoader) : (0, $1Zthr.UnarchivePagesDialogLoader), {
                    contentId: contentId,
                    source: $d360c48f6ab9e723$export$fbd5d3e319eba191
                });
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
            ...sectionItem,
            ...props,
            label: sectionItem.label,
            url: undefined,
            onClick: onClick
        });
    });
    return null;
}
function $d360c48f6ab9e723$var$ArchivePageItemComponent(arg0) {
    if ($d360c48f6ab9e723$var$isReactCompilerActiveV1_result) return $d360c48f6ab9e723$var$ArchivePageItemComponent_optimized(arg0);
    else return $d360c48f6ab9e723$var$ArchivePageItemComponent_unoptimized(arg0);
}



var $31PvZ = parcelRequire("31PvZ");

















var $3gadb = parcelRequire("3gadb");








var $1eaCJ = parcelRequire("1eaCJ");

















var $1KmJq = parcelRequire("1KmJq");





var $eEA8O = parcelRequire("eEA8O");


var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");











var $lsxnT = parcelRequire("lsxnT");


var $6oZiN = parcelRequire("6oZiN");


var $4XcQZ = parcelRequire("4XcQZ");

const $4f376e56ec220da4$var$EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation = (0, $eSUdr.default)`mutation EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation($type:String!$id:ID!$status:Boolean!){setRecommendedPagesStatus(input:{entityType:$type entityId:$id enableRecommendedPages:$status}){success errors{message}}}`;
const $4f376e56ec220da4$export$55e0baf10c9b177c = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { entityId: entityId, entityType: entityType, isOpen: isOpen, setIsOpen: setIsOpen, spaceKey: spaceKey } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== entityId || $[1] !== spaceKey) {
        t1 = {
            refetchQueries: [
                {
                    query: (0, $4XcQZ.EndOfPageRecommendationQuery),
                    variables: {
                        type: "page",
                        id: entityId,
                        exp: "end_of_page",
                        key: spaceKey
                    }
                }
            ]
        };
        $[0] = entityId;
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const [mutateHideStatus, t2] = (0, $1KmJq.useMutation)($4f376e56ec220da4$var$EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation, t1);
    const { error: error } = t2;
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== entityId || $[5] !== setIsOpen) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "page",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "hideEOPModalCancel",
                    attributes: {
                        contentId: entityId
                    }
                }
            }).fire();
            setIsOpen(false);
        };
        $[3] = createAnalyticsEvent;
        $[4] = entityId;
        $[5] = setIsOpen;
        $[6] = t3;
    } else t3 = $[6];
    const cancelModal = t3;
    let t4;
    if ($[7] !== createAnalyticsEvent || $[8] !== entityId || $[9] !== entityType || $[10] !== mutateHideStatus || $[11] !== setIsOpen) {
        t4 = ()=>{
            mutateHideStatus({
                variables: {
                    type: entityType,
                    id: entityId,
                    status: false
                }
            }).catch($4f376e56ec220da4$var$_temp);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "page",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "hideEOPModalConfirm",
                    attributes: {
                        contentId: entityId
                    }
                }
            }).fire();
            setIsOpen(false);
        };
        $[7] = createAnalyticsEvent;
        $[8] = entityId;
        $[9] = entityType;
        $[10] = mutateHideStatus;
        $[11] = setIsOpen;
        $[12] = t4;
    } else t4 = $[12];
    const confirmModal = t4;
    if (error) {
        let t5;
        if ($[13] !== error) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).SMARTS
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }));
            $[13] = error;
            $[14] = t5;
        } else t5 = $[14];
        return t5;
    }
    let t5;
    if ($[15] !== Modal || $[16] !== cancelModal || $[17] !== confirmModal || $[18] !== isOpen) {
        t5 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            onClose: cancelModal,
            testId: "eop-hide-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...(0, $6oZiN.i18n).modal_title,
            values: {
                b: $4f376e56ec220da4$var$_temp2
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $6oZiN.i18n).modal_info), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $6oZiN.i18n).modal_info_show)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "primary",
            onClick: confirmModal,
            testId: "eop-hide-modal-confirm",
            autoFocus: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $6oZiN.i18n).modal_hide))));
        $[15] = Modal;
        $[16] = cancelModal;
        $[17] = confirmModal;
        $[18] = isOpen;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t5);
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
} : ({ entityId: entityId, entityType: entityType, isOpen: isOpen, setIsOpen: setIsOpen, spaceKey: spaceKey })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const [mutateHideStatus, { error: error }] = (0, $1KmJq.useMutation)($4f376e56ec220da4$var$EndOfPageHideConfirmModalEndOfPageRecHideStatusMutation, {
        refetchQueries: [
            {
                query: (0, $4XcQZ.EndOfPageRecommendationQuery),
                variables: {
                    type: 'page',
                    id: entityId,
                    exp: 'end_of_page',
                    key: spaceKey
                }
            }
        ]
    });
    const cancelModal = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'hideEOPModalCancel',
                attributes: {
                    contentId: entityId
                }
            }
        }).fire();
        setIsOpen(false);
    }, [
        createAnalyticsEvent,
        setIsOpen,
        entityId
    ]);
    const confirmModal = (0, $42omo.useCallback)(()=>{
        mutateHideStatus({
            variables: {
                type: entityType,
                id: entityId,
                status: false
            }
        }).catch(()=>{
        // This is literally just to prevent jest from failing tests on error
        // behavior due to apparent "uncaught promise rejection." We actually
        // handle mutation error by deconstructing it above in the mutation hook
        // above and rendering an error component below.
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'hideEOPModalConfirm',
                attributes: {
                    contentId: entityId
                }
            }
        }).fire();
        setIsOpen(false);
    }, [
        createAnalyticsEvent,
        mutateHideStatus,
        setIsOpen,
        entityId,
        entityType
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: cancelModal,
        testId: "eop-hide-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...(0, $6oZiN.i18n).modal_title,
        values: {
            b: (boldWord)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, boldWord)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $6oZiN.i18n).modal_info), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $6oZiN.i18n).modal_info_show)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "primary",
        onClick: confirmModal,
        testId: "eop-hide-modal-confirm",
        autoFocus: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $6oZiN.i18n).modal_hide)))));
};
function $4f376e56ec220da4$var$_temp() {}
function $4f376e56ec220da4$var$_temp2(boldWord) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, boldWord);
}














class $a9e8fdac9b3f28d8$export$b326d77e4b8b7664 extends (0, $42omo.PureComponent) {
    createListener(itemId) {
        return ()=>{
            this.props.setActiveKeyboardShortcutHandler(()=>{
                (0, $4GDP8.simulateItemClick)(itemId);
            });
            (0, $4GDP8.openMenuClick)();
        };
    }
    render() {
        const { keyboardShortcuts: keyboardShortcuts, isAppNavigationShortcut: isAppNavigationShortcut } = this.props;
        return keyboardShortcuts.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, keyboardShortcuts.map(({ accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator, itemId: itemId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                key: Array.isArray(accelerator) ? accelerator.join('+') : accelerator,
                deprecatedAccelerator: deprecatedAccelerator,
                accelerator: accelerator,
                listener: this.createListener(itemId),
                isAppNavigationShortcut: isAppNavigationShortcut
            }))) : null;
    }
}
$a9e8fdac9b3f28d8$export$b326d77e4b8b7664.propTypes = {
    keyboardShortcuts: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).array,
    setActiveKeyboardShortcutHandler: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    isAppNavigationShortcut: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};



var $9MrOn = parcelRequire("9MrOn");


var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $de738cac831d4325$export$e3a22f680e471916 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MORE_ACTIONS_DROPDOWN_INTERACTION)
});


function $de8b5edaf84e1f06$var$_defineProperty(e, r, t) {
    return (r = $de8b5edaf84e1f06$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $de8b5edaf84e1f06$var$_toPropertyKey(t) {
    var i = $de8b5edaf84e1f06$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $de8b5edaf84e1f06$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $de8b5edaf84e1f06$var$SeparatedGroup = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_n7zl1uh4 _n3tdv77o _otyrv77o _1ragidpf _7mmmidpf _dmhjidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zl1uh4 _n3tdv77o _otyrv77o _1ragidpf _7mmmidpf _dmhjidpf",
            __cmplp.className
        ])
    });
});
const $de8b5edaf84e1f06$export$c0df4392cbc33974 = /*#__PURE__*/ (0, $42omo.createContext)((_)=>{});
class $de8b5edaf84e1f06$export$96b88272fadb65d0 extends (0, $42omo.PureComponent) {
    render() {
        const { itemSections: itemSections, keyboardShortcuts: keyboardShortcuts, contentId: contentId, contentType: contentType, spaceKey: spaceKey, isExternalCollaborator: isExternalCollaborator, isAppNavigationShortcut: isAppNavigationShortcut, isMenuOpen: isMenuOpen } = this.props;
        const { isEndOfPageHideConfirmOpen: isEndOfPageHideConfirmOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($de8b5edaf84e1f06$export$c0df4392cbc33974.Provider, {
            value: this.setMenuChangeAllowed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9e8fdac9b3f28d8$export$b326d77e4b8b7664), {
            keyboardShortcuts: keyboardShortcuts,
            setActiveKeyboardShortcutHandler: this.setActiveKeyboardShortcutHandler,
            isAppNavigationShortcut: isAppNavigationShortcut
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "content-tools.button.tooltip",
                defaultMessage: "More actions"
            }),
            hideTooltipOnClick: true,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton), {
            isDisabled: false,
            isOpen: isMenuOpen,
            onOpenChange: this.handleOpenChange,
            onPositioned: this.onPositioned,
            isExternalCollaborator: isExternalCollaborator
        }, itemSections.map((section, index)=>{
            // index should be safe as key because it's ordered
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($de8b5edaf84e1f06$var$SeparatedGroup, {
                key: index
            }, section);
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4f376e56ec220da4$export$55e0baf10c9b177c), {
            entityId: contentId,
            entityType: contentType,
            spaceKey: spaceKey,
            isOpen: isEndOfPageHideConfirmOpen,
            setIsOpen: this.setIsEndOfPageHideConfirmOpen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_EXPERIENCE)
        }));
    }
    constructor(...args){
        super(...args);
        $de8b5edaf84e1f06$var$_defineProperty(this, "state", {
            isMenuChangeAllowed: true,
            isEndOfPageHideConfirmOpen: false
        });
        $de8b5edaf84e1f06$var$_defineProperty(this, "activeKeyboardShortcutHandler", null);
        $de8b5edaf84e1f06$var$_defineProperty(this, "setActiveKeyboardShortcutHandler", (activeKeyboardShortcutHandler)=>{
            this.activeKeyboardShortcutHandler = activeKeyboardShortcutHandler;
        });
        $de8b5edaf84e1f06$var$_defineProperty(this, "onPositioned", ()=>{
            (0, $de738cac831d4325$export$e3a22f680e471916).stop();
        });
        $de8b5edaf84e1f06$var$_defineProperty(this, "handleOpenChange", ({ isOpen: isOpen })=>{
            if (!this.state.isMenuChangeAllowed) return;
            if (isOpen) (0, $de738cac831d4325$export$e3a22f680e471916).start();
            this.props.onOpenChange?.(isOpen);
            if (this.activeKeyboardShortcutHandler) {
                this.activeKeyboardShortcutHandler();
                this.activeKeyboardShortcutHandler = null;
            }
            this.fireToggleAnalyticsEvent();
        });
        $de8b5edaf84e1f06$var$_defineProperty(this, "setMenuChangeAllowed", (allowed)=>{
            this.setState({
                isMenuChangeAllowed: allowed
            });
        });
        $de8b5edaf84e1f06$var$_defineProperty(this, "closeDialog", ()=>{
            this.props.onOpenChange?.(false);
            this.setState({
                isMenuChangeAllowed: true
            });
        });
        $de8b5edaf84e1f06$var$_defineProperty(this, "setIsEndOfPageHideConfirmOpen", (isOpen)=>{
            this.setState({
                isEndOfPageHideConfirmOpen: isOpen
            });
        });
        $de8b5edaf84e1f06$var$_defineProperty(this, "fireToggleAnalyticsEvent", ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            createAnalyticsEvent?.({
                data: {
                    action: 'clicked',
                    actionSubject: 'moreIcon',
                    source: 'moreActions',
                    attributes: {
                        componentVersion: 'v2'
                    }
                },
                type: 'sendTrackEvent'
            }).fire();
        });
    }
}
$de8b5edaf84e1f06$var$_defineProperty($de8b5edaf84e1f06$export$96b88272fadb65d0, "defaultProps", {
    keyboardShortcuts: []
});
const $de8b5edaf84e1f06$export$53a21db1cb01b7aa = (0, $1DWH0.default)()($de8b5edaf84e1f06$export$96b88272fadb65d0);






var $dhbEh = parcelRequire("dhbEh");



























var $xQxzY = parcelRequire("xQxzY");














var $3sFtD = parcelRequire("3sFtD");














const $fdbc57468402c0e9$var$TitleWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_k48pi7a9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_k48pi7a9",
            __cmplp.className
        ])
    });
});
const $fdbc57468402c0e9$var$i18n = (0, $cgtv4.defineMessages)({
    hide: {
        id: "content-tools.eop.hide",
        defaultMessage: "Hide related content"
    },
    show: {
        id: "content-tools.eop.show",
        defaultMessage: "Show related content"
    },
    flag: {
        id: "content-tools.eop.flag.description",
        defaultMessage: "Automatically generated suggestions will appear below this content when available."
    },
    flag_results: {
        id: "content-tools.eop.flag.results",
        defaultMessage: "Automatically generated suggestions are now available below this content."
    },
    flag_results_title: {
        id: "content-tools.eop.flag.title",
        defaultMessage: "Related content shown"
    },
    flag_no_results: {
        id: "content-tools.eop.flag.no-results",
        defaultMessage: "Automatically generated suggestions will appear below this content once we have some to show you."
    },
    flag_refresh: {
        id: "content-tools.eop.flag.refresh",
        defaultMessage: "Refresh to check for related content"
    },
    show_tooltip: {
        id: "content-tools.eop.flag.tooltip",
        defaultMessage: "Related content is off for this space"
    }
});
const $fdbc57468402c0e9$export$fa6c0892f837d8a5 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(46);
    const { entityId: entityId, entityType: entityType, spaceKey: spaceKey, contentToolsRef: contentToolsRef } = t0;
    const toggleMenuChangeAllowed = (0, $42omo.useContext)((0, $de8b5edaf84e1f06$export$c0df4392cbc33974));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const skip = entityType !== "page";
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query EndOfPageRecMenuItemEndOfPageRecHideQuery($type:String!$id:ID!$exp:String!$key:ID!){getRecommendedPages(entityType:$type entityId:$id experience:$exp){recommendedPages{content{id}}status{userCanToggle isEnabled}}getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled}}`;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== entityId || $[2] !== spaceKey) {
        t2 = {
            type: "page",
            id: entityId,
            exp: "end_of_page",
            key: spaceKey
        };
        $[1] = entityId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== skip || $[5] !== t2) {
        t3 = {
            variables: t2,
            errorPolicy: "all",
            skip: skip
        };
        $[4] = skip;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const { error: error, data: data } = (0, $xQxzY.useQuery)(t1, t3);
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $eSUdr.default)`mutation EndOfPageRecMenuItemEndOfPageRecHideStatusMutation($type:String!$id:ID!$status:Boolean!){setRecommendedPagesStatus(input:{entityType:$type entityId:$id enableRecommendedPages:$status}){success errors{message}}}`;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== entityId || $[9] !== spaceKey) {
        t5 = {
            refetchQueries: [
                {
                    query: (0, $4XcQZ.EndOfPageRecommendationQuery),
                    variables: {
                        type: "page",
                        id: entityId,
                        exp: "end_of_page",
                        key: spaceKey
                    }
                }
            ]
        };
        $[8] = entityId;
        $[9] = spaceKey;
        $[10] = t5;
    } else t5 = $[10];
    const [mutateHideStatus, t6] = (0, $1KmJq.useMutation)(t4, t5);
    const { error: mutationError } = t6;
    const userCanToggle = data?.getRecommendedPages?.status?.userCanToggle;
    const endOfPageRecSpaceEnabled = data?.getRecommendedPagesSpaceStatus?.recommendedPagesEnabled;
    const isEnabled = data?.getRecommendedPages?.status?.isEnabled;
    const hasRecommendedPages = data?.getRecommendedPages?.recommendedPages.length;
    let t7;
    if ($[11] !== toggleMenuChangeAllowed) {
        t7 = (hovered)=>()=>{
                toggleMenuChangeAllowed(!hovered);
            };
        $[11] = toggleMenuChangeAllowed;
        $[12] = t7;
    } else t7 = $[12];
    const toggleEOPItemHover = t7;
    let t8;
    if ($[13] !== contentToolsRef || $[14] !== createAnalyticsEvent || $[15] !== entityId || $[16] !== entityType || $[17] !== hasRecommendedPages || $[18] !== isEnabled || $[19] !== mutateHideStatus || $[20] !== showFlag) {
        t8 = ()=>{
            contentToolsRef.closeDialog();
            if (isEnabled) {
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        source: "page",
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "hideEOPAdv",
                        attributes: {
                            contentId: entityId,
                            triggeredFrom: "actionsMenu"
                        }
                    }
                }).fire();
                contentToolsRef.setIsEndOfPageHideConfirmOpen(true);
            } else {
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        source: "page",
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "showEOPAdv",
                        attributes: {
                            contentId: entityId,
                            triggeredFrom: "actionsMenu"
                        }
                    }
                }).fire();
                mutateHideStatus({
                    variables: {
                        type: entityType,
                        id: entityId,
                        status: true
                    }
                });
                const flagTitle = hasRecommendedPages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.flag_results_title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdbc57468402c0e9$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.flag_no_results));
                const flagMessage = hasRecommendedPages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.flag_results) : null;
                showFlag({
                    title: flagTitle,
                    description: flagMessage,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                        color: "var(--ds-icon-success, #6A9A23)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
            }
        };
        $[13] = contentToolsRef;
        $[14] = createAnalyticsEvent;
        $[15] = entityId;
        $[16] = entityType;
        $[17] = hasRecommendedPages;
        $[18] = isEnabled;
        $[19] = mutateHideStatus;
        $[20] = showFlag;
        $[21] = t8;
    } else t8 = $[21];
    const clickMenu = t8;
    if (skip || !userCanToggle) return null;
    if (error) {
        let t9;
        if ($[22] !== error) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).SMARTS
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }));
            $[22] = error;
            $[23] = t9;
        } else t9 = $[23];
        return t9;
    }
    if (mutationError) {
        let t9;
        if ($[24] !== mutationError) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).SMARTS
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: mutationError
            }));
            $[24] = mutationError;
            $[25] = t9;
        } else t9 = $[25];
        return t9;
    }
    const t9 = !endOfPageRecSpaceEnabled;
    let t10;
    if ($[26] !== isEnabled) {
        t10 = isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.hide) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.show);
        $[26] = isEnabled;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== clickMenu || $[29] !== t10 || $[30] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            isDisabled: t9,
            onClick: clickMenu,
            testId: "eop-adv-menu-item"
        }, t10);
        $[28] = clickMenu;
        $[29] = t10;
        $[30] = t9;
        $[31] = t11;
    } else t11 = $[31];
    const endOfPageRecToggleAdvMenuItem = t11;
    let t12;
    let t13;
    let t14;
    let t15;
    if ($[32] !== toggleEOPItemHover) {
        t12 = toggleEOPItemHover(true);
        t13 = toggleEOPItemHover(false);
        t14 = toggleEOPItemHover(true);
        t15 = toggleEOPItemHover(false);
        $[32] = toggleEOPItemHover;
        $[33] = t12;
        $[34] = t13;
        $[35] = t14;
        $[36] = t15;
    } else {
        t12 = $[33];
        t13 = $[34];
        t14 = $[35];
        t15 = $[36];
    }
    let t16;
    if ($[37] !== endOfPageRecSpaceEnabled || $[38] !== endOfPageRecToggleAdvMenuItem) {
        t16 = endOfPageRecSpaceEnabled ? endOfPageRecToggleAdvMenuItem : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.show_tooltip),
            position: "mouse"
        }, endOfPageRecToggleAdvMenuItem);
        $[37] = endOfPageRecSpaceEnabled;
        $[38] = endOfPageRecToggleAdvMenuItem;
        $[39] = t16;
    } else t16 = $[39];
    let t17;
    if ($[40] !== t12 || $[41] !== t13 || $[42] !== t14 || $[43] !== t15 || $[44] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: t12,
            onMouseLeave: t13,
            onFocus: t14,
            onBlur: t15
        }, t16);
        $[40] = t12;
        $[41] = t13;
        $[42] = t14;
        $[43] = t15;
        $[44] = t16;
        $[45] = t17;
    } else t17 = $[45];
    return t17;
} : ({ entityId: entityId, entityType: entityType, spaceKey: spaceKey, contentToolsRef: contentToolsRef })=>{
    const toggleMenuChangeAllowed = (0, $42omo.useContext)((0, $de8b5edaf84e1f06$export$c0df4392cbc33974));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const skip = entityType !== 'page';
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { error: error, data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query EndOfPageRecMenuItemEndOfPageRecHideQuery($type:String!$id:ID!$exp:String!$key:ID!){getRecommendedPages(entityType:$type entityId:$id experience:$exp){recommendedPages{content{id}}status{userCanToggle isEnabled}}getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled}}`, {
        variables: {
            type: 'page',
            id: entityId,
            exp: 'end_of_page',
            key: spaceKey
        },
        errorPolicy: 'all',
        skip: skip
    });
    const [mutateHideStatus, { error: mutationError }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation EndOfPageRecMenuItemEndOfPageRecHideStatusMutation($type:String!$id:ID!$status:Boolean!){setRecommendedPagesStatus(input:{entityType:$type entityId:$id enableRecommendedPages:$status}){success errors{message}}}`, {
        refetchQueries: [
            {
                query: (0, $4XcQZ.EndOfPageRecommendationQuery),
                variables: {
                    type: 'page',
                    id: entityId,
                    exp: 'end_of_page',
                    key: spaceKey
                }
            }
        ]
    });
    const userCanToggle = data?.getRecommendedPages?.status?.userCanToggle;
    const endOfPageRecSpaceEnabled = data?.getRecommendedPagesSpaceStatus?.recommendedPagesEnabled;
    const isEnabled = data?.getRecommendedPages?.status?.isEnabled;
    const hasRecommendedPages = data?.getRecommendedPages?.recommendedPages.length;
    const toggleEOPItemHover = (0, $42omo.useCallback)((hovered)=>()=>{
            toggleMenuChangeAllowed(!hovered);
        }, [
        toggleMenuChangeAllowed
    ]);
    const clickMenu = (0, $42omo.useCallback)(()=>{
        contentToolsRef.closeDialog();
        if (isEnabled) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'page',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'hideEOPAdv',
                    attributes: {
                        contentId: entityId,
                        triggeredFrom: 'actionsMenu'
                    }
                }
            }).fire();
            contentToolsRef.setIsEndOfPageHideConfirmOpen(true);
        } else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'page',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'showEOPAdv',
                    attributes: {
                        contentId: entityId,
                        triggeredFrom: 'actionsMenu'
                    }
                }
            }).fire();
            mutateHideStatus({
                variables: {
                    type: entityType,
                    // FIXME this problem always existed added typecasting as a part of codemods,
                    id: entityId,
                    status: true
                }
            });
            const flagTitle = hasRecommendedPages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.flag_results_title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdbc57468402c0e9$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.flag_no_results));
            const flagMessage = hasRecommendedPages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.flag_results) : null;
            showFlag({
                title: flagTitle,
                description: flagMessage,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                    color: "var(--ds-icon-success, #6A9A23)",
                    label: ""
                }),
                isAutoDismiss: true
            });
        }
    }, [
        createAnalyticsEvent,
        mutateHideStatus,
        entityId,
        entityType,
        contentToolsRef,
        isEnabled,
        showFlag,
        hasRecommendedPages
    ]);
    if (skip || !userCanToggle) return null;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }));
    if (mutationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    }));
    const endOfPageRecToggleAdvMenuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        isDisabled: !endOfPageRecSpaceEnabled,
        onClick: clickMenu,
        testId: "eop-adv-menu-item"
    }, isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.hide) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.show));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: toggleEOPItemHover(true),
        onMouseLeave: toggleEOPItemHover(false),
        onFocus: toggleEOPItemHover(true),
        onBlur: toggleEOPItemHover(false)
    }, endOfPageRecSpaceEnabled ? endOfPageRecToggleAdvMenuItem : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $fdbc57468402c0e9$var$i18n.show_tooltip),
        position: "mouse"
    }, endOfPageRecToggleAdvMenuItem));
};



var $d8J72 = parcelRequire("d8J72");





















var $bTUBB = parcelRequire("bTUBB");




const $28b01bfb04c4bbb7$export$14f6050734c32ad5 = (webItems)=>{
    const firstParty = [];
    const thirdParty = [];
    for (const webItem of webItems)if (webItem?.['subSection'] === (0, $bTUBB.THIRD_PARTY)) {
        webItem['className'] = webItem.styleClass;
        thirdParty.push(webItem);
    } else firstParty.push(webItem);
    return {
        firstParty: firstParty,
        thirdParty: thirdParty
    };
};
const $28b01bfb04c4bbb7$export$37dfc787e4638a9d = (items)=>{
    'use no memo';
    const itemsCopy = [
        ...items
    ];
    // reorder Slack Notification to the beginning of the list
    const slackIntegrationMenuItemIndex = itemsCopy.findIndex((item)=>item?.id === 'confluence-chats-integration__page-config-dialog-trigger');
    if (slackIntegrationMenuItemIndex !== -1) {
        const slackIntegrationMenuItem = itemsCopy.splice(slackIntegrationMenuItemIndex, 1)[0];
        itemsCopy.splice(0, 0, slackIntegrationMenuItem);
    }
    return itemsCopy.filter(Boolean).map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItemWithPlaceholder), {
            key: item?.completeKey,
            ...item
        }));
};
const $28b01bfb04c4bbb7$export$b73d2abc48a9c9b8 = (thirdPartySection, itemSections)=>{
    const indexOfSectionWithAnalytics = itemSections.findIndex((section)=>{
        return section?.some?.((item)=>item?.key === 'confluence.content.action.menu.new:view-history');
    });
    if (indexOfSectionWithAnalytics === -1) return [
        ...itemSections,
        thirdPartySection
    ];
    else {
        // Create a copy so we don't mutate itemSections.
        const result = [
            ...itemSections
        ];
        result.splice(indexOfSectionWithAnalytics, 0, [
            thirdPartySection
        ]);
        return result;
    }
};
const $28b01bfb04c4bbb7$export$542fdc619d6f9a9a = ({ menuItems: menuItems, nestedPopup: nestedPopup, onSetPopup: onSetPopup })=>{
    'use no memo';
    const section = (0, $bTUBB.THIRD_PARTY);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        key: `${section}-dropdown`,
        placement: "auto-start",
        isOpen: nestedPopup === section,
        onOpenChange: ({ isOpen: isOpen })=>{
            if (isOpen) onSetPopup(section);
            else onSetPopup(undefined);
        },
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                ...triggerProps,
                ref: triggerRef,
                testId: `${section}-button`,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                defaultMessage: "Apps",
                id: "content-tools.third-party-apps.nested.section.heading"
            })),
        shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-trueenterprise-e')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, menuItems));
};


function $bd828e2c954a88da$var$_defineProperty(e, r, t) {
    return (r = $bd828e2c954a88da$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $bd828e2c954a88da$var$_toPropertyKey(t) {
    var i = $bd828e2c954a88da$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $bd828e2c954a88da$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $bd828e2c954a88da$var$TOOLS_MENU_LOCATION = 'system.content.action';
const $bd828e2c954a88da$var$ACTION_MENU_RESOLVED_INLINE_COMMENTS = 'view-resolved-comments';
const $bd828e2c954a88da$var$ACTION_MENU_PDF_EXPORT = 'action-export-pdf-link';
const $bd828e2c954a88da$var$ACTION_MENU_WORD_EXPORT = 'action-export-word-link';
const $bd828e2c954a88da$export$675cf65aa6633872 = 'action-move-page-dialog-link';
const $bd828e2c954a88da$export$90fcc80b18438f82 = 'action-export-web-item';
const $bd828e2c954a88da$export$a2dbc6850168e8f7 = 'action-convert-page-to-blog';
const $bd828e2c954a88da$export$1b47d37d2f7f0fb9 = 'view-attachments-link';
const $bd828e2c954a88da$export$b57a8f55173363f2 = 'view-custom-contents-link';
const $bd828e2c954a88da$var$LINK_TO_THIS_PAGE = 'link-to-page-link';
const $bd828e2c954a88da$export$dd4e73aef5173154 = 'action-view-source-link';
const $bd828e2c954a88da$var$LINK_TO_VIEW_HIERARCHY = 'view-in-hierarchy-link';
const $bd828e2c954a88da$var$LINK_TO_VIEW_STORAGE = 'action-view-storage-link';
const $bd828e2c954a88da$var$VIEW_CONTENT_API = 'content-api';
const $bd828e2c954a88da$var$IMPORT_WORD_DOC = 'import-word-doc';
const $bd828e2c954a88da$var$EXPORT = 'export';
const $bd828e2c954a88da$var$ADVANCED = 'advanced';
const $bd828e2c954a88da$export$d4a3d5bcb97ac918 = 'third-party';
const $bd828e2c954a88da$var$OTHERS = 'others';
const $bd828e2c954a88da$var$END_OF_PAGE_RECOMMENDATION_MENU = 'end-of-page-recommendation-menu';
const $bd828e2c954a88da$var$ATTACHMENTS = 'attachments';
const $bd828e2c954a88da$export$10f4bed2ae52719b = 'action-switch-to-live-edit';
const $bd828e2c954a88da$var$CONTENT_OWNER = 'content-owner';
const $bd828e2c954a88da$export$73ee567dd4df7468 = 'action-copy-page-link';
const $bd828e2c954a88da$var$PAGE_INFO_LINK = 'view-page-info-link';
const $bd828e2c954a88da$export$91e6cd1e6a1046d7 = 'contentToolsItem';
const $bd828e2c954a88da$export$62ff295bf30619dd = 'contentToolsItem';
const $bd828e2c954a88da$export$6e008fb6b6012cc4 = 'presentation-mode'; // NOTE: these same styles are used in MoreActions.tsx in @confluence/content-types-header
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd828e2c954a88da$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd828e2c954a88da$var$LabelContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlcs5v _1o9zkb7n _i0dlf1ug _2hwx12x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlcs5v _1o9zkb7n _i0dlf1ug _2hwx12x7",
            __cmplp.className
        ])
    });
});

const $bd828e2c954a88da$var$LazyContentToolsItemForCopy = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Sm2XD",
    name: "LazyContentToolsItemForCopy",
    loader: async ()=>(await (parcelRequire("fV9S6"))).ContentToolsItemForCopy
});
const $bd828e2c954a88da$var$LazyContentToolsItemForMove = (0, $3eMfQ.LazyContentToolsItem);
const $bd828e2c954a88da$var$i18n = (0, $cgtv4.defineMessages)({
    filesLabel: {
        defaultMessage: "Files",
        id: "content-tools.files.nested.section.heading.files"
    },
    customContentsLabel: {
        defaultMessage: "Custom Contents",
        id: "content-tools.files.nested.section.heading.custom-contents"
    }
});
class $bd828e2c954a88da$var$ContentToolsClass extends (0, $42omo.PureComponent) {
    createMenuItems(webItems, webSectionsKeys, dialogs, isSpaceOverview = false, isViewPage = true, isHistoryPage = false) {
        const { contentId: contentId, isFabricPage: isFabricPage, spaceKey: spaceKey, isContentToolsForcedOpen: isContentToolsForcedOpen, switchToLivePage: switchToLivePage, showCommentsPanel: showCommentsPanel, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = this.props;
        const sections = this.splitInSections(webItems);
        const itemSections = [];
        const keyboardShortcuts = []; //need support for web items
        const exportMenuGroupings = [];
        const advancedMenuGroupings = [];
        const thirdPartyMenuGroupings = [];
        const attachmentMenuGroupings = [];
        const commonProps = {};
        let revertEditorComponent; // First iteration: popuplate menu groupings arrays.
        (webSectionsKeys || Object.keys(sections)).forEach((key)=>{
            (sections[key] || []).forEach((sectionItem)=>{
                switch(sectionItem['subSection']){
                    case $bd828e2c954a88da$var$EXPORT:
                        exportMenuGroupings.push(sectionItem);
                        return;
                    case $bd828e2c954a88da$var$ADVANCED:
                        advancedMenuGroupings.push(sectionItem);
                        return;
                    case $bd828e2c954a88da$export$d4a3d5bcb97ac918:
                        // Necessary for some macros/apps especially for third party Connect macro/apps to render iframes/modals
                        // for some reason ¯\_(ツ)_/¯
                        sectionItem['className'] = sectionItem.styleClass;
                        thirdPartyMenuGroupings.push(sectionItem);
                        return;
                }
            });
        });
        // Second iteration: generate JSX to render
        (webSectionsKeys || Object.keys(sections)).forEach((key)=>{
            const sectionItemsComponent = (sections[key] || []).map((sectionItem)=>{
                // Skip over any `sectionItem`s that were already adding to a MenuGrouping above.
                switch(sectionItem['subSection']){
                    case $bd828e2c954a88da$var$EXPORT:
                        return null;
                    case $bd828e2c954a88da$var$ADVANCED:
                        return null;
                    case $bd828e2c954a88da$export$d4a3d5bcb97ac918:
                        return null;
                }
                if (sectionItem.id === (0, $31PvZ.REVERT_EDITOR_LINK)) {
                    //need to check if it is available and then push to the array at the end to put it at the bottom after third party section.
                    revertEditorComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                        attribution: (0, $3IBnw.Attribution).BACKBONE,
                        key: sectionItem.completeKey
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                        key: sectionItem.completeKey,
                        ...sectionItem,
                        ...commonProps,
                        url: undefined,
                        onClick: this.makeRevertEditorDialogOpener(dialogs)
                    }));
                    return null;
                }
                if (sectionItem.id === (0, $31PvZ.PAGE_HISTORY_LINK)) // Link component ignores query params so it still transitions instead of going to Next
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                    ...commonProps,
                    id: sectionItem.id,
                    label: sectionItem.label,
                    url: sectionItem.url,
                    key: sectionItem.completeKey
                });
                if (sectionItem.id === (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID) || sectionItem.id === (0, $hFGQl.ANALYTICS_MODERATE_ADDON_ACTIONS_MENU_ID)) {
                    // Replace the WebItem URL with the new native UI route URL
                    const url = (0, $3Syas.pageAnalyticsUrlToRouteUrl)(sectionItem.url);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iff8m.AnalyticsPluginWrapper), {
                        webItemId: sectionItem.id,
                        key: sectionItem.completeKey
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                        ...sectionItem,
                        url: url,
                        ...commonProps
                    }));
                }
                if (sectionItem.id === $bd828e2c954a88da$var$ACTION_MENU_RESOLVED_INLINE_COMMENTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                    ...commonProps,
                    id: "bm-resolved-inline-comments",
                    key: sectionItem.completeKey,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd828e2c954a88da$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd828e2c954a88da$var$LabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, sectionItem.label, " ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9BVDK.ResolvedInlineCommentsCounterLoader), {
                        contentId: contentId
                    })),
                    onClick: this.makeInlineCommentsDialogOpener(dialogs, showCommentsPanel, isFabricPage)
                });
                if (sectionItem.id === $bd828e2c954a88da$var$LINK_TO_THIS_PAGE) {
                    keyboardShortcuts.push({
                        accelerator: (0, $gnkil.UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT),
                        deprecatedAccelerator: (0, $gnkil.LINK_TO_THIS_PAGE_SHORTCUT),
                        itemId: sectionItem.id
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                        key: sectionItem.completeKey,
                        ...sectionItem,
                        url: "",
                        ...commonProps,
                        onClick: this.makeLinkToThisPageDialogOpener(dialogs)
                    });
                }
                if (sectionItem.id === $bd828e2c954a88da$export$73ee567dd4df7468) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd828e2c954a88da$var$LazyContentToolsItemForCopy, {
                    key: sectionItem.completeKey,
                    ...sectionItem,
                    url: "",
                    ...commonProps,
                    onClick: this.makeCopyPageTreeDialogOpener(dialogs)
                });
                if (sectionItem.id === $bd828e2c954a88da$export$6e008fb6b6012cc4) {
                    if (!isSpaceOverview && !isHistoryPage) {
                        keyboardShortcuts.push({
                            accelerator: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT),
                            deprecatedAccelerator: (0, $gnkil.PRESENTATION_MODE_SHORTCUT),
                            itemId: sectionItem.id
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                            attribution: (0, $3IBnw.Attribution).COMMENTS,
                            key: sectionItem.completeKey
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5KL6w.LazyPresenterModeContextConsumer), {
                            key: `presenter-mode-menu-item-${sectionItem.completeKey}`
                        }, (enterPresenterMode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItemWithPlaceholder), {
                                key: sectionItem.completeKey,
                                ...sectionItem,
                                url: "",
                                ...commonProps,
                                onClick: this.makePresenterModeOpener(enterPresenterMode),
                                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd828e2c954a88da$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd828e2c954a88da$var$LabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, sectionItem.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                                    shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT)
                                }))
                            })));
                    }
                    return null;
                }
                if (sectionItem.id === (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID)) {
                    if (isViewPage) {
                        const handleOnClick = ()=>{
                            if (this.state?.nestedPopup === $bd828e2c954a88da$var$CONTENT_OWNER) this.setState({
                                nestedPopup: undefined
                            });
                            else this.setState({
                                nestedPopup: $bd828e2c954a88da$var$CONTENT_OWNER
                            });
                        };
                        const handleClosePopup = ()=>{
                            this.setState({
                                nestedPopup: undefined
                            });
                        };
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                            attribution: (0, $3IBnw.Attribution).BACKBONE,
                            key: sectionItem.completeKey
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jcM8h.ContentOwnerPopupComponent), {
                            key: `container-${sectionItem.id}`,
                            itemId: sectionItem.id,
                            contentId: contentId,
                            itemLabel: sectionItem.label,
                            onCloseParent: this.closeDropdownMenu,
                            onClosePopup: handleClosePopup,
                            isOpen: this.state?.nestedPopup === $bd828e2c954a88da$var$CONTENT_OWNER,
                            onClick: handleOnClick
                        }));
                    }
                    return null;
                }
                if (sectionItem.id === $bd828e2c954a88da$export$a2dbc6850168e8f7) {
                    if (isViewPage && isFabricPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                        key: sectionItem.completeKey,
                        ...sectionItem,
                        url: "",
                        ...commonProps,
                        onClick: this.makePublishPageAsBlogDialogOpener(dialogs)
                    });
                    return null;
                }
                if (sectionItem.id === (0, $gjbSq.CONVERT_PAGE_TO_FOLDER_WEBITEM_ID)) {
                    if (isViewPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8J72.ConvertToFolderItem), {
                        key: sectionItem.completeKey,
                        sectionItem: {
                            ...sectionItem,
                            url: '',
                            urlWithoutContextPath: ''
                        },
                        contentId: contentId,
                        spaceKey: spaceKey,
                        dialogs: dialogs,
                        shouldHighlight: isContentToolsForcedOpen,
                        ...commonProps
                    });
                    return null;
                }
                if (sectionItem.id === $bd828e2c954a88da$export$1b47d37d2f7f0fb9) {
                    const sectionItemForCustomContents = {
                        id: $bd828e2c954a88da$export$b57a8f55173363f2,
                        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                        label: 'Custom Contents',
                        url: (0, $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST).toUrl({
                            contentId: contentId,
                            spaceKey: spaceKey
                        }),
                        accessKey: null,
                        completeKey: 'confluence.content.action.menu.new:view-custom-contents',
                        hasCondition: true,
                        icon: null,
                        subSection: $bd828e2c954a88da$var$ATTACHMENTS
                    };
                    attachmentMenuGroupings.push(sectionItem);
                    attachmentMenuGroupings.push(sectionItemForCustomContents);
                    return this.getSectionComponent(attachmentMenuGroupings, $bd828e2c954a88da$var$ATTACHMENTS, dialogs, contentId, sectionItem.label);
                }
                sectionItem['className'] = sectionItem.styleClass;
                if (sectionItem.id === (0, $31PvZ.DELETE_PAGE_LINK)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                    attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE,
                    key: sectionItem.completeKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, ({ edition: edition })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                        key: sectionItem.completeKey,
                        ...sectionItem,
                        ...commonProps,
                        url: undefined,
                        onClick: this.makeDeletePageDialogOpener(dialogs, edition)
                    })));
                if (sectionItem.id === (0, $d360c48f6ab9e723$export$c133e27c6e67b0b2) || sectionItem.id === (0, $d360c48f6ab9e723$export$1ee3e7befe1441e1)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d360c48f6ab9e723$export$1c76cced151657ae), {
                    key: sectionItem.completeKey,
                    ...commonProps,
                    contentId: contentId,
                    sectionItem: sectionItem
                });
                if (sectionItem.id === (0, $31PvZ.ACTION_MOVE_BLOG_DIALOG) || sectionItem.id === $bd828e2c954a88da$export$675cf65aa6633872) {
                    const makeDialogOpener = sectionItem.id === (0, $31PvZ.ACTION_MOVE_BLOG_DIALOG) ? 'makeModernizedMoveBlogModalOpener' : 'makeModernizedMovePageDialogOpener';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd828e2c954a88da$var$LazyContentToolsItemForMove, {
                        key: sectionItem.completeKey,
                        ...sectionItem,
                        url: "",
                        id: `${sectionItem.id}-modernized`,
                        ...commonProps,
                        onClick: this[makeDialogOpener](dialogs)
                    });
                }
                if (sectionItem.id === $bd828e2c954a88da$export$10f4bed2ae52719b) {
                    if (!isHistoryPage && isLivePagesFeatureEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                        key: sectionItem.completeKey,
                        ...sectionItem,
                        url: "",
                        ...commonProps,
                        onClick: switchToLivePage
                    });
                    return null;
                }
                if (sectionItem.id === $bd828e2c954a88da$export$90fcc80b18438f82) {
                    if (key === 'system.content.action/modify' && !this.props.allowedContentToolsItems) return this.getSectionComponent(exportMenuGroupings, $bd828e2c954a88da$var$EXPORT, dialogs, contentId, sectionItem.label);
                    return null;
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                    key: sectionItem.completeKey,
                    ...sectionItem
                });
            }).filter((item)=>!!item);
            if (key === 'system.content.action/primary' && !this.props.allowedContentToolsItems) {
                const inlineCommentsMenuItemIndex = sectionItemsComponent.findIndex((sectionItem)=>sectionItem?.['key'] === 'com.atlassian.confluence.plugins.confluence-inline-comments:view-resolved-comments-new');
                const advancedSectionComponent = this.getSectionComponent(advancedMenuGroupings, $bd828e2c954a88da$var$ADVANCED, dialogs, contentId, undefined);
                sectionItemsComponent.splice(inlineCommentsMenuItemIndex + 1, 0, advancedSectionComponent);
            }
            if (sectionItemsComponent.length > 0) itemSections.push(sectionItemsComponent);
        });
        if (!this.props.allowedContentToolsItems) {
            // reorder Slack Notification to the beginning of the list
            const slackIntegrationMenuItemIndex = thirdPartyMenuGroupings.findIndex((item)=>item.id === 'confluence-chats-integration__page-config-dialog-trigger');
            const slackIntegrationMenuItem = thirdPartyMenuGroupings.splice(slackIntegrationMenuItemIndex, 1)[0];
            thirdPartyMenuGroupings.splice(0, 0, slackIntegrationMenuItem);
            const thirdPartyMenuGroupingsComponent = thirdPartyMenuGroupings.filter(Boolean).map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItemWithPlaceholder), {
                    key: item.completeKey,
                    ...item,
                    ...commonProps
                }));
            if (thirdPartyMenuGroupingsComponent.length > 0) itemSections.push(thirdPartyMenuGroupingsComponent);
        }
        if (revertEditorComponent) itemSections.push(revertEditorComponent);
        return {
            itemSections: itemSections,
            keyboardShortcuts: keyboardShortcuts
        };
    }
    render() {
        const { contentId: contentId, onRender: onRender } = this.props;
        onRender?.();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $kRW4Y.DialogsStateContainer)
            ]
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, (routesContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, this.renderMenuItems({
                    contentId: contentId,
                    dialogs: dialogs,
                    routesContext: routesContext
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                deprecatedAccelerator: (0, $gnkil.LINK_TO_THIS_PAGE_SHORTCUT),
                accelerator: (0, $gnkil.UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT),
                listener: this.makeLinkToThisPageDialogOpener(dialogs)
            })))));
    }
    constructor(...args){
        super(...args);
        $bd828e2c954a88da$var$_defineProperty(this, "context", void 0);
        $bd828e2c954a88da$var$_defineProperty(this, "contentToolsComponentRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef());
        $bd828e2c954a88da$var$_defineProperty(this, "splitInSections", (webItems)=>webItems ? (0, (/*@__PURE__*/$parcel$interopDefault($1wScy)))(webItems, 'section') : {});
        $bd828e2c954a88da$var$_defineProperty(this, "makePublishPageAsBlogDialogOpener", (dialogs)=>()=>{
                const { contentId: contentId, createAnalyticsEvent: createAnalyticsEvent, spaceKey: spaceKey } = this.props;
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'publishPageAsBlog',
                        source: 'contentToolsItem'
                    }
                }).fire();
                dialogs.showDialog((0, $k9WFY.PublishPageAsBlogDialog), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    source: (0, $iVd6X.PublishPageAsBlogSources).ViewPage
                });
            });
        $bd828e2c954a88da$var$_defineProperty(this, "makePresenterModeOpener", (enterPresenterMode)=>()=>{
                const { contentId: contentId, createAnalyticsEvent: createAnalyticsEvent, experienceTracker: experienceTracker, spaceId: spaceId, theme: theme } = this.props;
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'present',
                        source: 'moreActions',
                        objectId: contentId,
                        containerId: spaceId,
                        attributes: {
                            currentThemePreference: theme,
                            OStheme: (0, $5yVAS.getSystemPreferredColorScheme)()
                        }
                    }
                }).fire();
                experienceTracker.start({
                    name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
                });
                enterPresenterMode();
            });
        $bd828e2c954a88da$var$_defineProperty(this, "makeChangeOwnershipOpener", (openChangeOwnership)=>()=>{
                const { contentId: contentId, createAnalyticsEvent: createAnalyticsEvent } = this.props;
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'page.owner',
                        source: 'moreActions',
                        objectId: contentId
                    }
                }).fire();
                openChangeOwnership();
            });
        $bd828e2c954a88da$var$_defineProperty(this, "makeDeletePageDialogOpener", (dialogs, edition)=>()=>{
                const { contentId: contentId, contentType: contentType, createAnalyticsEvent: createAnalyticsEvent, experienceTracker: experienceTracker } = this.props;
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'deletePage',
                        source: $bd828e2c954a88da$export$91e6cd1e6a1046d7,
                        attributes: {
                            showArchiveUpsell: edition === (0, $euL71.ConfluenceEdition).FREE
                        }
                    }
                }).fire();
                experienceTracker.start({
                    name: (0, $irVI7.DELETE_PAGE_EXPERIENCE)
                });
                dialogs.showModal((0, $6ykQV.DeleteNestedPagesActionLoader), {
                    contentId: contentId,
                    source: 'contentToolsItem',
                    shouldRedirectOnSuccess: true,
                    contentType: contentType
                });
            });
        $bd828e2c954a88da$var$_defineProperty(this, "makeRevertEditorDialogOpener", (dialogs)=>async ()=>{
                const { contentId: contentId, createAnalyticsEvent: createAnalyticsEvent } = this.props;
                (0, $cQhbe.sendEditorConversionAnalyticsPageEvent)(createAnalyticsEvent, {
                    pageAction: (0, $cQhbe.RevertAutoConvertEvent).DIALOG_OPEN,
                    source: 'ViewPageAutoConversion'
                }, (0, $cQhbe.AutoConvertActionSubject).AUTO_CONVERSION);
                dialogs.showDialog((0, $b66o6.RevertEditorDialog), {
                    contentId: contentId
                });
            });
        $bd828e2c954a88da$var$_defineProperty(this, "makeLinkToThisPageDialogOpener", (dialogs)=>()=>{
                const { contentId: contentId } = this.props;
                dialogs.showDialog((0, $1PC5x.LinkToThisPageDialog), {
                    contentId: contentId
                });
            });
        $bd828e2c954a88da$var$_defineProperty(this, "makeCopyPageTreeDialogOpener", (dialogs)=>()=>{
                const { contentId: contentId, spaceKey: spaceKey } = this.props;
                dialogs.showDialog((0, $5FwhF.CopyPageTreeDialog), {
                    contentId: contentId,
                    spaceKey: spaceKey
                });
            });
        $bd828e2c954a88da$var$_defineProperty(this, "makeInlineCommentsDialogOpener", (dialogs, showCommentsPanel, isFabricPage)=>()=>{
                if (isFabricPage && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    return;
                }
                const { contentId: contentId, spaceKey: spaceKey } = this.props;
                dialogs.showDialog((0, $6eFi0.ResolvedInlineCommentsDialogLoader), {
                    spaceKey: spaceKey,
                    contentId: contentId,
                    context: 'renderer'
                });
            });
        $bd828e2c954a88da$var$_defineProperty(this, "makeModernizedMovePageDialogOpener", (dialogs)=>()=>{
                const { contentId: contentId, createAnalyticsEvent: createAnalyticsEvent, experienceTracker: experienceTracker, spaceKey: spaceKey } = this.props;
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'move',
                        source: 'contentToolsItem',
                        objectType: 'page'
                    }
                }).fire();
                experienceTracker.start({
                    name: (0, $irVI7.MOVE_PAGE_DIALOG_LOAD_EXPERIENCE)
                });
                dialogs.showDialog((0, $bHd1w.MovePageDialog), {
                    spaceKey: spaceKey,
                    contentId: contentId,
                    referrer: 'view-page-actions-menu'
                });
            });
        $bd828e2c954a88da$var$_defineProperty(this, "makeModernizedMoveBlogModalOpener", (dialogs)=>()=>{
                const { contentId: contentId, createAnalyticsEvent: createAnalyticsEvent, spaceKey: spaceKey } = this.props;
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'move',
                        source: 'contentToolsItem',
                        objectType: 'blog'
                    }
                }).fire();
                dialogs.showModal((0, $78wUU.MoveBlogModalLoader), {
                    currentSpaceKey: spaceKey,
                    blogPostId: contentId,
                    isEditMode: false,
                    isUnpublishedDraft: false,
                    referrer: 'view-page-actions-menu'
                });
            });
        $bd828e2c954a88da$var$_defineProperty(this, "navigateToAttachments", (push, url)=>()=>{
                push(url);
            });
        $bd828e2c954a88da$var$_defineProperty(this, "closeDropdownMenu", ()=>{
            this.setState({
                nestedPopup: undefined,
                isDropdownMenuOpen: false
            });
        });
        $bd828e2c954a88da$var$_defineProperty(this, "getSectionComponent", (menuGroupings, section, dialogs, contentId, triggerLabel)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
                key: `${section}-dropdown`,
                placement: "auto-start",
                isOpen: this.state?.nestedPopup === section,
                onOpenChange: ({ isOpen: isOpen })=>{
                    if (isOpen) this.setState({
                        nestedPopup: section
                    });
                    else this.setState({
                        nestedPopup: undefined
                    });
                },
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                        ...triggerProps,
                        ref: triggerRef,
                        testId: `${section}-button`,
                        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                            label: "",
                            color: "var(--ds-icon, #292A2E)",
                            size: "small"
                        })
                    }, section === $bd828e2c954a88da$var$EXPORT && // when backend supplies a label, use that instead.
                    (triggerLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, triggerLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                        defaultMessage: "Export",
                        id: "content-tools.export.nested.section.heading"
                    })), section === $bd828e2c954a88da$var$ADVANCED && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                        defaultMessage: "Advanced details",
                        id: "content-tools.advanced.nested.section.heading"
                    }), section === $bd828e2c954a88da$var$ATTACHMENTS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                        defaultMessage: "Attachments",
                        id: "content-tools.attachments.nested.section.heading"
                    })),
                shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-trueenterprise-e')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, menuGroupings.filter(Boolean).map((sectionItem)=>{
                if (sectionItem.id === $bd828e2c954a88da$var$LINK_TO_THIS_PAGE) // analytics to monitor the roll out of removal of Link to this page from page actions menu
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
                    key: sectionItem.completeKey,
                    analyticsData: {
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'LinkToThisPageButton',
                            source: 'viewPageScreen',
                            attributes: {
                                triggeredFrom: 'actionsMenu'
                            }
                        }
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                    key: sectionItem.completeKey,
                    ...sectionItem,
                    url: "",
                    onClick: this.makeLinkToThisPageDialogOpener(dialogs)
                }));
                else if (sectionItem.id === $bd828e2c954a88da$var$LINK_TO_VIEW_HIERARCHY) // analytics to monitor the roll out of removal of View In Hierarchy from page actions menu
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
                    key: sectionItem.completeKey,
                    analyticsData: {
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'ViewInHierarchyButton',
                            source: 'viewPageScreen',
                            attributes: {
                                triggeredFrom: 'actionsMenu'
                            }
                        }
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                    key: sectionItem.completeKey,
                    ...sectionItem
                }));
                else if (sectionItem.id === $bd828e2c954a88da$var$END_OF_PAGE_RECOMMENDATION_MENU) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdbc57468402c0e9$export$fa6c0892f837d8a5), {
                    key: sectionItem.completeKey,
                    entityId: contentId,
                    entityType: this.props.contentType,
                    spaceKey: this.props.spaceKey,
                    contentToolsRef: this.contentToolsComponentRef.current
                });
                else if (sectionItem.id === $bd828e2c954a88da$export$1b47d37d2f7f0fb9) {
                    // Renaming inner Attachments-label to "Files"
                    const label = this.props.intl.formatMessage($bd828e2c954a88da$var$i18n.filesLabel);
                    const attachmentsCountStr = sectionItem?.label?.match(/\d+/g)?.[0] || '';
                    const newLabel = `${label} (${attachmentsCountStr})`;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
                        key: sectionItem.completeKey,
                        analyticsData: (0, $7XPIt.ATTACHMENTS_ANALYTICS_FROM_ACTIONS_MENU)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                        ...sectionItem,
                        label: newLabel
                    }));
                } else if (sectionItem.id === $bd828e2c954a88da$export$b57a8f55173363f2) {
                    // TODO: make a call (gql.content() when ready) to get numberOfCustomContentTypes
                    const label = this.props.intl.formatMessage($bd828e2c954a88da$var$i18n.customContentsLabel);
                    const numStr = '';
                    const newLabel = `${label} (${numStr})`;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
                        key: sectionItem.completeKey,
                        analyticsData: {
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'ViewCustomContentsButton',
                                source: 'contentToolMenu',
                                attributes: {
                                    triggeredFrom: 'actionsMenu'
                                }
                            }
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                        ...sectionItem,
                        label: newLabel
                    }));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                    key: sectionItem.completeKey,
                    ...sectionItem
                });
            }), section === $bd828e2c954a88da$var$EXPORT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e21594c46d184a7$export$978ddac74253162e), {
                closeDropdownMenu: this.closeDropdownMenu,
                contentId: contentId
            })));
        });
        $bd828e2c954a88da$var$_defineProperty(this, "groupWebItemsBySubSection", (webItems)=>{
            webItems.forEach((webItem)=>{
                if ([
                    $bd828e2c954a88da$var$ACTION_MENU_WORD_EXPORT,
                    $bd828e2c954a88da$var$ACTION_MENU_PDF_EXPORT
                ].indexOf(webItem.id) !== -1) webItem['subSection'] = $bd828e2c954a88da$var$EXPORT;
                else if ([
                    $bd828e2c954a88da$var$LINK_TO_THIS_PAGE,
                    $bd828e2c954a88da$var$PAGE_INFO_LINK,
                    $bd828e2c954a88da$export$dd4e73aef5173154,
                    $bd828e2c954a88da$var$LINK_TO_VIEW_HIERARCHY,
                    $bd828e2c954a88da$var$LINK_TO_VIEW_STORAGE,
                    $bd828e2c954a88da$var$VIEW_CONTENT_API,
                    $bd828e2c954a88da$var$IMPORT_WORD_DOC,
                    $bd828e2c954a88da$var$END_OF_PAGE_RECOMMENDATION_MENU
                ].indexOf(webItem.id) !== -1) webItem['subSection'] = $bd828e2c954a88da$var$ADVANCED;
                else if ((webItem.completeKey ?? '').indexOf((0, $jBnsv.CONNECT_APP_PREFIX_KEY)) !== -1 && webItem.id !== (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID) && webItem.id !== (0, $hFGQl.ANALYTICS_MODERATE_ADDON_ACTIONS_MENU_ID)) webItem['subSection'] = $bd828e2c954a88da$export$d4a3d5bcb97ac918;
                else if ([
                    $bd828e2c954a88da$var$ATTACHMENTS,
                    $bd828e2c954a88da$export$b57a8f55173363f2
                ].indexOf(webItem.id) !== -1) webItem['subSection'] = $bd828e2c954a88da$var$ATTACHMENTS;
                else webItem['subSection'] = $bd828e2c954a88da$var$OTHERS;
            });
        });
        $bd828e2c954a88da$var$_defineProperty(this, "getAllowedWebItems", (webItems)=>{
            if (this.props.allowedContentToolsItems) return webItems.filter((sectionItem)=>this.props.allowedContentToolsItems.includes(sectionItem.id));
            return webItems;
        });
        $bd828e2c954a88da$var$_defineProperty(this, "addEndofPageRecommendationToWebItems", (webItems)=>[
                ...webItems,
                {
                    accessKey: null,
                    completeKey: $bd828e2c954a88da$var$END_OF_PAGE_RECOMMENDATION_MENU,
                    hasCondition: true,
                    icon: null,
                    id: $bd828e2c954a88da$var$END_OF_PAGE_RECOMMENDATION_MENU,
                    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                    label: 'Hide related pages...',
                    moduleKey: 'end-of-page-recommendation-menu',
                    section: 'system.content.action/primary',
                    webSection: 'secondary'
                }
            ]);
        $bd828e2c954a88da$var$_defineProperty(this, "renderMenuItems", ({ contentId: contentId, dialogs: dialogs, routesContext: { match: match, push: push } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
                tagName: "span",
                location: $bd828e2c954a88da$var$TOOLS_MENU_LOCATION,
                hasMultipleSections: true,
                contentId: contentId,
                version: this.props.version ?? undefined,
                renderWhenLoading: true
            }, ({ loading: loading, webItems: webItems, webSections: webSections })=>{
                const { contentType: contentType, isExternalCollaborator: isExternalCollaborator, spaceKey: spaceKey, isContentToolsForcedOpen: isContentToolsForcedOpen, setIsContentToolsForcedOpen: setIsContentToolsForcedOpen } = this.props;
                if (loading) {
                    if (this.props.allowedContentToolsItems?.length == 0) return null;
                     // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                    const isPageSSRd = Boolean((0, window.__SSR_RENDERED__));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton), {
                        isDisabled: !isPageSSRd
                    }));
                }
                webItems = this.addEndofPageRecommendationToWebItems(webItems);
                const allowedWebItems = this.getAllowedWebItems(webItems);
                this.groupWebItemsBySubSection(allowedWebItems);
                const isSpaceOverview = match?.name === (0, $1NBp8.SPACE_OVERVIEW).name;
                const isViewPage = match?.name === (0, $1NBp8.VIEW_PAGE).name;
                const isHistoryPage = match?.name === (0, $1NBp8.CONTENT_HISTORY).name;
                let thirdPartyWebItems = [];
                const partitionResult = (0, $28b01bfb04c4bbb7$export$14f6050734c32ad5)(allowedWebItems);
                thirdPartyWebItems = partitionResult.thirdParty;
                const createMenuItemsResult = this.createMenuItems(partitionResult.firstParty, webSections, dialogs, isSpaceOverview, isViewPage, isHistoryPage);
                const { itemSections: itemSections, keyboardShortcuts: keyboardShortcuts } = createMenuItemsResult; /* For EP View Page when item-sections is empty do not render content tools */ 
                if (this.props.allowedContentToolsItems && itemSections.length == 0) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dhbEh.ForgeContentTools), {
                    spaceKey: spaceKey,
                    contentId: contentId,
                    onLoadComplete: ()=>{
                        this.contentToolsComponentRef.current?.closeDialog();
                    },
                    isDropdownMenuOpen: this.state?.isDropdownMenuOpen ?? false
                }, (forgeMenuItems)=>{
                    let result = itemSections;
                    let thirdPartyComponentList = [];
                    if (forgeMenuItems.length) {
                        const tooltippedForgeMenuItems = forgeMenuItems.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                                key: f.props.extension.id,
                                module: f.props.extension
                            }, f));
                        thirdPartyComponentList = [
                            ...(0, $28b01bfb04c4bbb7$export$37dfc787e4638a9d)(thirdPartyWebItems),
                            ...tooltippedForgeMenuItems
                        ];
                    } else // If there aren't any Forge apps, combine the non-Forge
                    // third party apps into a single list of components.
                    thirdPartyComponentList = (0, $28b01bfb04c4bbb7$export$37dfc787e4638a9d)(thirdPartyWebItems);
                     // If there are third party components, which implies that the feature,
                    // we turn the third party components into a nested "Apps" menu and insert
                    // it into the full menu, ideally splicing it to appear before the section
                    // that contains the "Page history" component, as is done for live pages.
                    if (thirdPartyComponentList.length) {
                        const thirdPartySection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $28b01bfb04c4bbb7$export$542fdc619d6f9a9a), {
                            nestedPopup: this.state?.nestedPopup,
                            onSetPopup: (popup)=>this.setState({
                                    nestedPopup: popup
                                }),
                            menuItems: thirdPartyComponentList
                        });
                        result = (0, $28b01bfb04c4bbb7$export$b73d2abc48a9c9b8)(thirdPartySection, result);
                    }
                    const forgeKeyboardShortcuts = forgeMenuItems.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
                            key: f.props.extension.id,
                            module: f.props.extension,
                            action: ()=>{
                                (0, $4GDP8.openForgeAppFromSubmenu)({
                                    parentmenuId: '#tools-menu-trigger',
                                    submenuId: "[data-testid='third-party-button']",
                                    forgeItemId: f.props.extension.id
                                });
                            }
                        }));
                    const viewAttachmentsWebItem = webItems.find((webItem)=>webItem.id === $bd828e2c954a88da$export$1b47d37d2f7f0fb9);
                    const viewAttachmentsShotcutListener = viewAttachmentsWebItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                        deprecatedAccelerator: (0, $gnkil.VIEW_ATTACHMENTS_SHORTCUT),
                        accelerator: (0, $4tOXV.isMac)() ? (0, $gnkil.UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC) : (0, $gnkil.UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN),
                        listener: this.navigateToAttachments(push, viewAttachmentsWebItem.url)
                    }) : null;
                    const isMenuOpen = !!this.state?.isDropdownMenuOpen || isContentToolsForcedOpen || false;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $de8b5edaf84e1f06$export$53a21db1cb01b7aa), {
                        contentType: contentType,
                        key: "content-tools-component",
                        contentId: contentId,
                        itemSections: result,
                        keyboardShortcuts: keyboardShortcuts,
                        ref: this.contentToolsComponentRef,
                        isMenuOpen: isMenuOpen,
                        onOpenChange: (isOpen)=>{
                            if (!this.state?.nestedPopup) {
                                this.setState({
                                    isDropdownMenuOpen: isOpen
                                });
                                if (isContentToolsForcedOpen && !isOpen) setIsContentToolsForcedOpen && setIsContentToolsForcedOpen(false);
                            }
                        },
                        spaceKey: spaceKey,
                        isExternalCollaborator: isExternalCollaborator
                    }), forgeKeyboardShortcuts, viewAttachmentsShotcutListener);
                });
            }));
    }
}
$bd828e2c954a88da$var$_defineProperty($bd828e2c954a88da$var$ContentToolsClass, "propTypes", {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    version: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
    onRender: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    experienceTracker: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    isFabricPage: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
   * Used by Embedded Pages to specify the identifiers of allowed
   * `ContentToolsItem`s. An emtpy array means that no `ContentToolsItem`s are
   * allowed and, consequently, `ContentTools` will not render a menu at all.
   * For Confluence all `ContentToolItem`s will be allowed!
   */ allowedContentToolsItems: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string),
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        light: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        colorMode: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
    }),
    isContentToolsForcedOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    setIsContentToolsForcedOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
});
const $bd828e2c954a88da$var$withHooks = (Component)=>{
    return (props)=>{
        const spaceId = (0, $7QM6o.useSpaceId)();
        const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
        const { push: push } = (0, $dPJCf.useRouteActions)();
        const switchToLivePage = (0, $BCkug.useSwitchToLivePage)({
            contentId: props.contentId,
            spaceId: spaceId,
            // Since this component is only used on the view page, isUnpublishedDraft must be false.
            isUnpublishedDraft: false,
            analyticsSource: 'viewPageScreen',
            adfOrigin: 'RENDERER',
            onSuccessfulConversion: ()=>{
                push((0, $1NBp8.VIEW_PAGE).toUrl({
                    spaceKey: props.spaceKey,
                    contentId: props.contentId
                }, // do not remove this query param. It is used to force a transition since the route is the same
                // and we need to force a transition to avoid using SSR data.
                {
                    query: {
                        [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    }
                }));
            },
            flags: props.flags,
            retrieveEditorTitleAndContent: undefined
        });
        const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            spaceId: spaceId,
            switchToLivePage: switchToLivePage,
            showCommentsPanel: showCommentsPanel,
            isLivePagesFeatureEnabled: isLivePagesFeatureEnabled,
            ...props
        });
    };
};
const $bd828e2c954a88da$export$8e3d4e3d40a48fc4 = (0, $7aRa9.withFlags)($bd828e2c954a88da$var$withHooks((0, $f0NfR.withSessionData)((0, $1kHsc.withExperienceTracker)(// @ts-ignore
(0, $1DWH0.default)()((0, $ec1e4df6a0d98d1f$export$a35b8a8c09d7df35)((0, $gmMgo.default)($bd828e2c954a88da$var$ContentToolsClass)))))));
module.exports["ACTION_MOVE_PAGE_DIALOG"] = $bd828e2c954a88da$export$675cf65aa6633872;
module.exports["ACTION_EXPORT_WEB_ITEM"] = $bd828e2c954a88da$export$90fcc80b18438f82;
module.exports["ACTION_PUBLISH_PAGE_AS_BLOG_DIALOG"] = $bd828e2c954a88da$export$a2dbc6850168e8f7;
module.exports["VIEW_ATTACHMENTS_LINK"] = $bd828e2c954a88da$export$1b47d37d2f7f0fb9;
module.exports["VIEW_CUSTOM_CONTENTS_LINK"] = $bd828e2c954a88da$export$b57a8f55173363f2;
module.exports["LINK_TO_VIEW_SOURCE"] = $bd828e2c954a88da$export$dd4e73aef5173154;
module.exports["THIRD_PARTY"] = $bd828e2c954a88da$export$d4a3d5bcb97ac918;
module.exports["SWITCH_TO_LIVE_EDIT_WEB_ITEM"] = $bd828e2c954a88da$export$10f4bed2ae52719b;
module.exports["COPY_PAGE_LINK"] = $bd828e2c954a88da$export$73ee567dd4df7468;
module.exports["DELETE_BUTTON_ANALYTICS_SOURCE"] = $bd828e2c954a88da$export$91e6cd1e6a1046d7;
module.exports["REVERT_BUTTON_ANALYTICS_SOURCE"] = $bd828e2c954a88da$export$62ff295bf30619dd;
module.exports["PRESENTATION_MODE"] = $bd828e2c954a88da$export$6e008fb6b6012cc4;
module.exports["ContentTools"] = $bd828e2c954a88da$export$8e3d4e3d40a48fc4;

});

parcelRegister("1wScy", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $77wHb = parcelRequire("77wHb");

/** Used for built-in method references. */ var $11d2d2e303d6c19d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $11d2d2e303d6c19d$var$hasOwnProperty = $11d2d2e303d6c19d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $11d2d2e303d6c19d$var$groupBy = $77wHb(function(result, value, key) {
    if ($11d2d2e303d6c19d$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $3PAnx(result, key, [
        value
    ]);
});
module.exports = $11d2d2e303d6c19d$var$groupBy;

});

parcelRegister("77wHb", function(module, exports) {

var $gETEr = parcelRequire("gETEr");


var $bSxMj = parcelRequire("bSxMj");


var $hWvFC = parcelRequire("hWvFC");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $52f28c800c0dec0e$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $fZxmY(collection) ? $gETEr : $bSxMj, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hWvFC(iteratee, 2), accumulator);
    };
}
module.exports = $52f28c800c0dec0e$var$createAggregator;

});

parcelRegister("gETEr", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c20b8cf123ccbac3$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $c20b8cf123ccbac3$var$arrayAggregator;

});

parcelRegister("bSxMj", function(module, exports) {

var $iawSg = parcelRequire("iawSg");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $8a5ef07d195ea024$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $iawSg(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $8a5ef07d195ea024$var$baseAggregator;

});

parcelRegister("iawSg", function(module, exports) {

var $fh4WQ = parcelRequire("fh4WQ");


var $fKRi0 = parcelRequire("fKRi0");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d3a2a94fdae59b54$var$baseEach = $fKRi0($fh4WQ);
module.exports = $d3a2a94fdae59b54$var$baseEach;

});

parcelRegister("fh4WQ", function(module, exports) {

var $9d5GH = parcelRequire("9d5GH");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b1ec481d92afa1cf$var$baseForOwn(object, iteratee) {
    return object && $9d5GH(object, iteratee, $d6TaN);
}
module.exports = $b1ec481d92afa1cf$var$baseForOwn;

});

parcelRegister("fKRi0", function(module, exports) {

var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b7847d143ef17a3d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$bRRFB(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b7847d143ef17a3d$var$createBaseEach;

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("6ykQV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cf5e0ab73c00afb3$export$25f686fb78162d50 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fmQ7C",
    name: "DeleteNestedPagesActionLoader",
    loader: async ()=>(await (parcelRequire("aHCxy"))).DeleteNestedPagesAction
});
module.exports["DeleteNestedPagesActionLoader"] = $cf5e0ab73c00afb3$export$25f686fb78162d50;

});

parcelRegister("aHCxy", function(module, exports) {

let $7cabd0cde8b039f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7cabd0cde8b039f5$var$load("kHOMt"),
    $7cabd0cde8b039f5$var$load("6wr18"),
    $7cabd0cde8b039f5$var$load("73HOd"),
    $7cabd0cde8b039f5$var$load("iQ0Jm"),
    $7cabd0cde8b039f5$var$load("a4yJG"),
    $7cabd0cde8b039f5$var$load("Wowvf"),
    $7cabd0cde8b039f5$var$load("ffEVr"),
    $7cabd0cde8b039f5$var$load("jXx9i"),
    $7cabd0cde8b039f5$var$load("nbjnv"),
    $7cabd0cde8b039f5$var$load("9ftJe"),
    $7cabd0cde8b039f5$var$load("hhss7"),
    $7cabd0cde8b039f5$var$load("9YGIy")
]).then(()=>parcelRequire('9R4ZE'));

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $9buj5 = parcelRequire("9buj5");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("5gChR"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("jEw5U"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("2jqNx"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("aGZxv"))).CommentsPanelWrapper
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const { handleMarkCommentsAsRead: handleMarkCommentsAsRead } = (0, $9buj5.useUnreadPanelComments)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const [shouldClearUnreads, setShouldClearUnreads] = (0, $42omo.useState)(false);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    // Required to invoke handleMarkCommentsAsRead and if any commentsMarkedAsRead
    // then we will call the MarkCommentsReadMutation Mutation
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (shouldClearUnreads) handleMarkCommentsAsRead();
        return ()=>{
            setShouldClearUnreads(false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldClearUnreads,
        setShouldClearUnreads
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        setShouldClearUnreads(true);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        if ((0, $6mKj3.expValEquals)('confluence_comments_5766_bugfix', 'isEnabled', true)) setReplyToCommentId();
    };
    const onPanelCloseCallback = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        setShouldClearUnreads,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const onPanelClose = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? onPanelCloseCallback : onPanelCloseFunction;
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = (0, $9wGTI.fg)('confluence_comment_footercomments_editpage') ? pageMode !== (0, $cD1qu.PageMode).EDIT : true;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon : undefined,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelFilterMenu : undefined
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView
                }),
            FooterComponent: canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            }
        }, 'push');
    };
    const showCommentsPanelHandler = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    const showCommentsPanel = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? showCommentsPanelHandler : showCommentsPanelFunction;
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("21K7m", function(module, exports) {

var $5rDjV = parcelRequire("5rDjV");

var $b38ed7ab605aa654$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $b38ed7ab605aa654$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($5rDjV)))();
    }
}
module.exports["AnnotationUpdateEvent"] = $b38ed7ab605aa654$export$c1c4b33b4e7b1c70;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $9VQUw.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    if (isTemplateBrowserEnabled) allowedEllipsisButtons.push("template-browser");
    const isSpacePickerDisabled = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'] ?? false;
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: isTemplateBrowserEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        loomExternalOpenRoute: loomExternalOpenRoute
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("fN3iy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = (props)=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)();
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ()=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");

const $9ee4137247832c84$var$getExperimentValue = (0, $c6GJD.default).getExperimentValue;
const $9ee4137247832c84$var$EXPERIMENT = 'platform_global_preview_panels_default_width';
const $9ee4137247832c84$export$c82b124a4ae0f274 = 'isEnabled';
const $9ee4137247832c84$export$56368731b0f4a091 = 'minimumWidth';
const $9ee4137247832c84$export$97a0618f336c05be = 'ratio';
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$FALLBACK_RATIO = 0.25;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    if (!$9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$c82b124a4ae0f274, false)) return $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    const windowWidth = window.innerWidth;
    const minWidthForWiderPanel = $9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$56368731b0f4a091, Number.MAX_VALUE);
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth > minWidthForWiderPanel) {
        const panelWidthToWindowWidthRatio = $9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$97a0618f336c05be, $9ee4137247832c84$var$FALLBACK_RATIO);
        const proposedPanelWidth = Math.round(windowWidth * panelWidthToWindowWidthRatio);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    return PanelName;
}({});
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;

});

parcelRegister("aSsfA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
} : ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("de2j9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
} : ()=>(0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        commentsMarkedAsRead: {
            inline: {},
            general: {}
        },
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType)=>({ setState: setState })=>{
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType
            });
        },
    setCommentsInThreadToBeMarkedAsRead: ({ threadKey: threadKey, commentIds: commentIds, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            const { commentsMarkedAsRead: commentsMarkedAsRead } = getState();
            if (threadKey && commentIds) {
                // Add the new comment IDs to the existing set for the specific parent
                const updatedCommentIds = {
                    ...commentsMarkedAsRead
                };
                const existingIdsSet = updatedCommentIds[commentType][threadKey] || new Set();
                commentIds.forEach((id)=>existingIdsSet.add(id));
                // Update the map with the new set of IDs
                updatedCommentIds[commentType][threadKey] = existingIdsSet;
                setState({
                    commentsMarkedAsRead: updatedCommentIds
                });
            }
        },
    setCommentsToBeMarkedAsRead: (commentsMarkedAsRead)=>({ setState: setState })=>{
            setState({
                commentsMarkedAsRead: commentsMarkedAsRead
            });
        },
    clearCommentsMarkedAsRead: ()=>({ setState: setState })=>{
            setState({
                commentsMarkedAsRead: {
                    inline: {},
                    general: {}
                }
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("dANtQ", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $eSUdr.default)`query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId status:["draft" "current"]){nodes{id type operations{operation targetType}}}}`;
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const { data: data, loading: loading, error: error, refetch: refetch, networkStatus: networkStatus } = (0, $xQxzY.useQuery)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        variables: {
            contentId: contentId
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network',
        skip: !contentId
    });
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("gEtAQ", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("9buj5", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");


var $8i27m = parcelRequire("8i27m");


var $fHAwL = parcelRequire("fHAwL");


var $3mVfX = parcelRequire("3mVfX");


var $9wGTI = parcelRequire("9wGTI");

const $02faaefae22f6672$var$useUnreadPanelCommentsMarkInlineCommentsReadMutation = (0, $eSUdr.default)`mutation useUnreadPanelCommentsMarkInlineCommentsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success errors}}`;
const $02faaefae22f6672$export$b2c07ec1a20446f7 = ()=>{
    const [{ commentsMarkedAsRead: commentsMarkedAsRead }, { clearCommentsMarkedAsRead: clearCommentsMarkedAsRead }] = (0, $3mVfX.useCommentsPanel)();
    const { updateUnreadStatus: updateUnreadStatus } = (0, $8i27m.useCommentsDataActions)();
    const [{ readCommentsListState: readCommentsListState, unreadCommentsListState: unreadCommentsListState }, { updateReadCommentsListState: updateReadCommentsListState, updateUnreadCommentsListState: updateUnreadCommentsListState }] = (0, $fHAwL.useUnreadComments)();
    // TODO: handle error
    const [markInlineCommentsRead] = (0, $1KmJq.useMutation)($02faaefae22f6672$var$useUnreadPanelCommentsMarkInlineCommentsReadMutation);
    // call the mutation to mark the list of comment IDs as read
    const handleMarkCommentsAsRead = (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (Object.keys(commentsMarkedAsRead.inline).length > 0 || Object.keys(commentsMarkedAsRead.general).length > 0) {
            const inlineCommentIdsToMarkAsRead = Object.values(commentsMarkedAsRead.inline).reduce((acc, set)=>{
                acc.push(...set);
                return acc;
            }, []);
            const generalCommentIdsToMarkAsRead = Object.values(commentsMarkedAsRead.general).reduce((acc, set)=>{
                acc.push(...set);
                return acc;
            }, []);
            const commentIdsToMarkAsRead = [
                ...inlineCommentIdsToMarkAsRead,
                ...generalCommentIdsToMarkAsRead
            ];
            if (!commentIdsToMarkAsRead?.length) return;
            markInlineCommentsRead({
                variables: {
                    commentIds: commentIdsToMarkAsRead
                }
            });
            // update our data store to indicate these comments are now read
            updateUnreadStatus(commentsMarkedAsRead, (0, $8i27m.UnreadAction).READ);
            // reset our list of comments to mark as read
            clearCommentsMarkedAsRead();
            // update existing unread and read data stores
            const commentIdsToMarkAsReadSet = new Set(commentIdsToMarkAsRead);
            const filteredUnreadComments = unreadCommentsListState.filter((unreadComment)=>!commentIdsToMarkAsReadSet.has(unreadComment.id));
            updateUnreadCommentsListState(()=>filteredUnreadComments);
            const newReadCommentsListState = new Set([
                ...readCommentsListState,
                ...commentIdsToMarkAsRead
            ]);
            updateReadCommentsListState(()=>newReadCommentsListState);
        }
    }, [
        markInlineCommentsRead,
        clearCommentsMarkedAsRead,
        commentsMarkedAsRead,
        updateUnreadStatus,
        readCommentsListState,
        unreadCommentsListState,
        updateReadCommentsListState,
        updateUnreadCommentsListState
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        const handleBeforeUnload = ()=>{
            // Mark comments as read if the user closes the window
            handleMarkCommentsAsRead();
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            // Mark comments as read when the component unmounts
            handleMarkCommentsAsRead();
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, $42omo.useMemo)(()=>({
            handleMarkCommentsAsRead: handleMarkCommentsAsRead
        }), [
        handleMarkCommentsAsRead
    ]);
};
module.exports["useUnreadPanelComments"] = $02faaefae22f6672$export$b2c07ec1a20446f7;

});

parcelRegister("5gChR", function(module, exports) {

let $3d5c25695369a044$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3d5c25695369a044$var$load("9jS5g"),
    $3d5c25695369a044$var$load("3ySTn"),
    $3d5c25695369a044$var$load("c2rHL"),
    $3d5c25695369a044$var$load("jSdjl"),
    $3d5c25695369a044$var$load("l2EUC"),
    $3d5c25695369a044$var$load("kHOMt"),
    $3d5c25695369a044$var$load("7Ewqa"),
    $3d5c25695369a044$var$load("1QdXB"),
    $3d5c25695369a044$var$load("goLL0"),
    $3d5c25695369a044$var$load("e4Jl9"),
    $3d5c25695369a044$var$load("22RDk"),
    $3d5c25695369a044$var$load("2JYqE"),
    $3d5c25695369a044$var$load("ev7SX"),
    $3d5c25695369a044$var$load("8VT23"),
    $3d5c25695369a044$var$load("cPWI2"),
    $3d5c25695369a044$var$load("lkOIY"),
    $3d5c25695369a044$var$load("clQc9"),
    $3d5c25695369a044$var$load("8PPsf"),
    $3d5c25695369a044$var$load("1iUSs"),
    $3d5c25695369a044$var$load("jbxHq"),
    $3d5c25695369a044$var$load("8YSo7"),
    $3d5c25695369a044$var$load("k8XPW"),
    $3d5c25695369a044$var$load("fWCRm"),
    $3d5c25695369a044$var$load("9ijrN"),
    $3d5c25695369a044$var$load("amdBm"),
    $3d5c25695369a044$var$load("Wowvf"),
    $3d5c25695369a044$var$load("cyGuT"),
    $3d5c25695369a044$var$load("lLssJ"),
    $3d5c25695369a044$var$load("5aBKc"),
    $3d5c25695369a044$var$load("6kZfp"),
    $3d5c25695369a044$var$load("2UbDA"),
    $3d5c25695369a044$var$load("fZt2F"),
    $3d5c25695369a044$var$load("7u4WP"),
    $3d5c25695369a044$var$load("am4CM"),
    $3d5c25695369a044$var$load("d6s42"),
    $3d5c25695369a044$var$load("gZGoR"),
    $3d5c25695369a044$var$load("jk2zg"),
    $3d5c25695369a044$var$load("zjNVa"),
    $3d5c25695369a044$var$load("9IeAj"),
    $3d5c25695369a044$var$load("6iKyY"),
    $3d5c25695369a044$var$load("9iZkh"),
    $3d5c25695369a044$var$load("kUbUu"),
    $3d5c25695369a044$var$load("1u0nB"),
    $3d5c25695369a044$var$load("brSj1"),
    $3d5c25695369a044$var$load("8ublV"),
    $3d5c25695369a044$var$load("e8XZq"),
    $3d5c25695369a044$var$load("hKZFn"),
    $3d5c25695369a044$var$load("coTx0"),
    $3d5c25695369a044$var$load("6wr18"),
    $3d5c25695369a044$var$load("ffEVr"),
    $3d5c25695369a044$var$load("gYeBT"),
    $3d5c25695369a044$var$load("gLGsg"),
    $3d5c25695369a044$var$load("nbjnv"),
    $3d5c25695369a044$var$load("flGQy"),
    $3d5c25695369a044$var$load("jwWp5"),
    $3d5c25695369a044$var$load("hhss7"),
    $3d5c25695369a044$var$load("7EorR"),
    $3d5c25695369a044$var$load("awqCy"),
    $3d5c25695369a044$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("jEw5U", function(module, exports) {

let $e4eaa6014f0074e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4eaa6014f0074e4$var$load("9jS5g"),
    $e4eaa6014f0074e4$var$load("3ySTn"),
    $e4eaa6014f0074e4$var$load("c2rHL"),
    $e4eaa6014f0074e4$var$load("jSdjl"),
    $e4eaa6014f0074e4$var$load("l2EUC"),
    $e4eaa6014f0074e4$var$load("kHOMt"),
    $e4eaa6014f0074e4$var$load("7Ewqa"),
    $e4eaa6014f0074e4$var$load("1QdXB"),
    $e4eaa6014f0074e4$var$load("goLL0"),
    $e4eaa6014f0074e4$var$load("e4Jl9"),
    $e4eaa6014f0074e4$var$load("22RDk"),
    $e4eaa6014f0074e4$var$load("2JYqE"),
    $e4eaa6014f0074e4$var$load("ev7SX"),
    $e4eaa6014f0074e4$var$load("8VT23"),
    $e4eaa6014f0074e4$var$load("cPWI2"),
    $e4eaa6014f0074e4$var$load("lkOIY"),
    $e4eaa6014f0074e4$var$load("clQc9"),
    $e4eaa6014f0074e4$var$load("8PPsf"),
    $e4eaa6014f0074e4$var$load("1iUSs"),
    $e4eaa6014f0074e4$var$load("jbxHq"),
    $e4eaa6014f0074e4$var$load("8YSo7"),
    $e4eaa6014f0074e4$var$load("k8XPW"),
    $e4eaa6014f0074e4$var$load("fWCRm"),
    $e4eaa6014f0074e4$var$load("9ijrN"),
    $e4eaa6014f0074e4$var$load("amdBm"),
    $e4eaa6014f0074e4$var$load("Wowvf"),
    $e4eaa6014f0074e4$var$load("cyGuT"),
    $e4eaa6014f0074e4$var$load("lLssJ"),
    $e4eaa6014f0074e4$var$load("5aBKc"),
    $e4eaa6014f0074e4$var$load("6kZfp"),
    $e4eaa6014f0074e4$var$load("2UbDA"),
    $e4eaa6014f0074e4$var$load("fZt2F"),
    $e4eaa6014f0074e4$var$load("7u4WP"),
    $e4eaa6014f0074e4$var$load("am4CM"),
    $e4eaa6014f0074e4$var$load("d6s42"),
    $e4eaa6014f0074e4$var$load("gZGoR"),
    $e4eaa6014f0074e4$var$load("jk2zg"),
    $e4eaa6014f0074e4$var$load("zjNVa"),
    $e4eaa6014f0074e4$var$load("9IeAj"),
    $e4eaa6014f0074e4$var$load("6iKyY"),
    $e4eaa6014f0074e4$var$load("9iZkh"),
    $e4eaa6014f0074e4$var$load("kUbUu"),
    $e4eaa6014f0074e4$var$load("1u0nB"),
    $e4eaa6014f0074e4$var$load("brSj1"),
    $e4eaa6014f0074e4$var$load("8ublV"),
    $e4eaa6014f0074e4$var$load("e8XZq"),
    $e4eaa6014f0074e4$var$load("hKZFn"),
    $e4eaa6014f0074e4$var$load("coTx0"),
    $e4eaa6014f0074e4$var$load("6wr18"),
    $e4eaa6014f0074e4$var$load("ffEVr"),
    $e4eaa6014f0074e4$var$load("gYeBT"),
    $e4eaa6014f0074e4$var$load("gLGsg"),
    $e4eaa6014f0074e4$var$load("nbjnv"),
    $e4eaa6014f0074e4$var$load("flGQy"),
    $e4eaa6014f0074e4$var$load("jwWp5"),
    $e4eaa6014f0074e4$var$load("hhss7"),
    $e4eaa6014f0074e4$var$load("7EorR"),
    $e4eaa6014f0074e4$var$load("awqCy"),
    $e4eaa6014f0074e4$var$load("bZz7X")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("2jqNx", function(module, exports) {

let $1af224a23a4e593a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1af224a23a4e593a$var$load("9jS5g"),
    $1af224a23a4e593a$var$load("3ySTn"),
    $1af224a23a4e593a$var$load("c2rHL"),
    $1af224a23a4e593a$var$load("jSdjl"),
    $1af224a23a4e593a$var$load("l2EUC"),
    $1af224a23a4e593a$var$load("kHOMt"),
    $1af224a23a4e593a$var$load("7Ewqa"),
    $1af224a23a4e593a$var$load("1QdXB"),
    $1af224a23a4e593a$var$load("goLL0"),
    $1af224a23a4e593a$var$load("e4Jl9"),
    $1af224a23a4e593a$var$load("22RDk"),
    $1af224a23a4e593a$var$load("2JYqE"),
    $1af224a23a4e593a$var$load("ev7SX"),
    $1af224a23a4e593a$var$load("8VT23"),
    $1af224a23a4e593a$var$load("cPWI2"),
    $1af224a23a4e593a$var$load("lkOIY"),
    $1af224a23a4e593a$var$load("clQc9"),
    $1af224a23a4e593a$var$load("8PPsf"),
    $1af224a23a4e593a$var$load("1iUSs"),
    $1af224a23a4e593a$var$load("jbxHq"),
    $1af224a23a4e593a$var$load("8YSo7"),
    $1af224a23a4e593a$var$load("k8XPW"),
    $1af224a23a4e593a$var$load("fWCRm"),
    $1af224a23a4e593a$var$load("9ijrN"),
    $1af224a23a4e593a$var$load("amdBm"),
    $1af224a23a4e593a$var$load("Wowvf"),
    $1af224a23a4e593a$var$load("cyGuT"),
    $1af224a23a4e593a$var$load("lLssJ"),
    $1af224a23a4e593a$var$load("5aBKc"),
    $1af224a23a4e593a$var$load("6kZfp"),
    $1af224a23a4e593a$var$load("2UbDA"),
    $1af224a23a4e593a$var$load("fZt2F"),
    $1af224a23a4e593a$var$load("7u4WP"),
    $1af224a23a4e593a$var$load("am4CM"),
    $1af224a23a4e593a$var$load("d6s42"),
    $1af224a23a4e593a$var$load("gZGoR"),
    $1af224a23a4e593a$var$load("jk2zg"),
    $1af224a23a4e593a$var$load("zjNVa"),
    $1af224a23a4e593a$var$load("9IeAj"),
    $1af224a23a4e593a$var$load("6iKyY"),
    $1af224a23a4e593a$var$load("9iZkh"),
    $1af224a23a4e593a$var$load("kUbUu"),
    $1af224a23a4e593a$var$load("1u0nB"),
    $1af224a23a4e593a$var$load("brSj1"),
    $1af224a23a4e593a$var$load("8ublV"),
    $1af224a23a4e593a$var$load("e8XZq"),
    $1af224a23a4e593a$var$load("hKZFn"),
    $1af224a23a4e593a$var$load("coTx0"),
    $1af224a23a4e593a$var$load("6wr18"),
    $1af224a23a4e593a$var$load("ffEVr"),
    $1af224a23a4e593a$var$load("gYeBT"),
    $1af224a23a4e593a$var$load("gLGsg"),
    $1af224a23a4e593a$var$load("nbjnv"),
    $1af224a23a4e593a$var$load("flGQy"),
    $1af224a23a4e593a$var$load("jwWp5"),
    $1af224a23a4e593a$var$load("hhss7"),
    $1af224a23a4e593a$var$load("7EorR"),
    $1af224a23a4e593a$var$load("awqCy"),
    $1af224a23a4e593a$var$load("bZz7X")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("aGZxv", function(module, exports) {

let $7c8d9012761a5dcb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7c8d9012761a5dcb$var$load("9jS5g"),
    $7c8d9012761a5dcb$var$load("3ySTn"),
    $7c8d9012761a5dcb$var$load("c2rHL"),
    $7c8d9012761a5dcb$var$load("jSdjl"),
    $7c8d9012761a5dcb$var$load("l2EUC"),
    $7c8d9012761a5dcb$var$load("kHOMt"),
    $7c8d9012761a5dcb$var$load("7Ewqa"),
    $7c8d9012761a5dcb$var$load("1QdXB"),
    $7c8d9012761a5dcb$var$load("goLL0"),
    $7c8d9012761a5dcb$var$load("e4Jl9"),
    $7c8d9012761a5dcb$var$load("22RDk"),
    $7c8d9012761a5dcb$var$load("2JYqE"),
    $7c8d9012761a5dcb$var$load("ev7SX"),
    $7c8d9012761a5dcb$var$load("8VT23"),
    $7c8d9012761a5dcb$var$load("cPWI2"),
    $7c8d9012761a5dcb$var$load("lkOIY"),
    $7c8d9012761a5dcb$var$load("clQc9"),
    $7c8d9012761a5dcb$var$load("8PPsf"),
    $7c8d9012761a5dcb$var$load("1iUSs"),
    $7c8d9012761a5dcb$var$load("jbxHq"),
    $7c8d9012761a5dcb$var$load("8YSo7"),
    $7c8d9012761a5dcb$var$load("k8XPW"),
    $7c8d9012761a5dcb$var$load("fWCRm"),
    $7c8d9012761a5dcb$var$load("9ijrN"),
    $7c8d9012761a5dcb$var$load("amdBm"),
    $7c8d9012761a5dcb$var$load("Wowvf"),
    $7c8d9012761a5dcb$var$load("cyGuT"),
    $7c8d9012761a5dcb$var$load("lLssJ"),
    $7c8d9012761a5dcb$var$load("5aBKc"),
    $7c8d9012761a5dcb$var$load("6kZfp"),
    $7c8d9012761a5dcb$var$load("2UbDA"),
    $7c8d9012761a5dcb$var$load("fZt2F"),
    $7c8d9012761a5dcb$var$load("7u4WP"),
    $7c8d9012761a5dcb$var$load("am4CM"),
    $7c8d9012761a5dcb$var$load("d6s42"),
    $7c8d9012761a5dcb$var$load("gZGoR"),
    $7c8d9012761a5dcb$var$load("jk2zg"),
    $7c8d9012761a5dcb$var$load("zjNVa"),
    $7c8d9012761a5dcb$var$load("9IeAj"),
    $7c8d9012761a5dcb$var$load("6iKyY"),
    $7c8d9012761a5dcb$var$load("9iZkh"),
    $7c8d9012761a5dcb$var$load("kUbUu"),
    $7c8d9012761a5dcb$var$load("1u0nB"),
    $7c8d9012761a5dcb$var$load("brSj1"),
    $7c8d9012761a5dcb$var$load("8ublV"),
    $7c8d9012761a5dcb$var$load("e8XZq"),
    $7c8d9012761a5dcb$var$load("hKZFn"),
    $7c8d9012761a5dcb$var$load("coTx0"),
    $7c8d9012761a5dcb$var$load("6wr18"),
    $7c8d9012761a5dcb$var$load("ffEVr"),
    $7c8d9012761a5dcb$var$load("gYeBT"),
    $7c8d9012761a5dcb$var$load("gLGsg"),
    $7c8d9012761a5dcb$var$load("nbjnv"),
    $7c8d9012761a5dcb$var$load("flGQy"),
    $7c8d9012761a5dcb$var$load("jwWp5"),
    $7c8d9012761a5dcb$var$load("hhss7"),
    $7c8d9012761a5dcb$var$load("7EorR"),
    $7c8d9012761a5dcb$var$load("awqCy"),
    $7c8d9012761a5dcb$var$load("bZz7X")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("3Syas", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $bd6cd55121384b66$export$3ef1b18b48cd8e50 = (relativeUrl)=>{
    if (!relativeUrl) return '';
    // First, extract everything in the relative URL after the '?' in the URL
    const queryParams = new URLSearchParams(relativeUrl.split('?')[1] || '');
    // Extract the space key and content ID from the query params
    const spaceKey = queryParams.get('space.key') || '';
    const contentId = queryParams.get('content.id') || '';
    if (!spaceKey || !contentId) return '';
    return (0, $1NBp8.PAGE_ANALYTICS).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
};
module.exports["pageAnalyticsUrlToRouteUrl"] = $bd6cd55121384b66$export$3ef1b18b48cd8e50;

});

parcelRegister("5FwhF", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ee4e9cc4db58f73d$export$b3f442789ed34bf1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1MHkm",
    name: "CopyPageTreeDialog",
    loader: async ()=>(await (parcelRequire("8ycis"))).CopyPageTreeContainer
});
module.exports["CopyPageTreeDialog"] = $ee4e9cc4db58f73d$export$b3f442789ed34bf1;

});

parcelRegister("8ycis", function(module, exports) {

let $639b0990ba8b9ec8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $639b0990ba8b9ec8$var$load("6wr18"),
    $639b0990ba8b9ec8$var$load("5ppK3"),
    $639b0990ba8b9ec8$var$load("7WcBh"),
    $639b0990ba8b9ec8$var$load("lnnYm"),
    $639b0990ba8b9ec8$var$load("lUQAm"),
    $639b0990ba8b9ec8$var$load("ffEVr"),
    $639b0990ba8b9ec8$var$load("kHOMt"),
    $639b0990ba8b9ec8$var$load("hhss7"),
    $639b0990ba8b9ec8$var$load("jXx9i"),
    $639b0990ba8b9ec8$var$load("7u4WP"),
    $639b0990ba8b9ec8$var$load("Wowvf"),
    $639b0990ba8b9ec8$var$load("7EorR"),
    $639b0990ba8b9ec8$var$load("kUbUu"),
    $639b0990ba8b9ec8$var$load("p4ay7")
]).then(()=>parcelRequire('c7g9a'));

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("4vC63", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("1PC5x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $297029061926b2dd$export$77691412571457f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8jq35",
    name: "LinkToThisPageDialog",
    loader: async ()=>(await (parcelRequire("kAUIk"))).LinkToThisPageDialog
});
module.exports["LinkToThisPageDialog"] = $297029061926b2dd$export$77691412571457f;

});

parcelRegister("kAUIk", function(module, exports) {

let $efe329a656fda19c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $efe329a656fda19c$var$load("kHOMt"),
    $efe329a656fda19c$var$load("hhss7"),
    $efe329a656fda19c$var$load("Wowvf"),
    $efe329a656fda19c$var$load("dXoLf")
]).then(()=>parcelRequire('gaLJH'));

});

parcelRegister("bHd1w", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f760397570928c6$export$28f6951b4656036e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AuHVu",
    name: "MovePageDialog",
    loader: async ()=>(await (parcelRequire("3Fd01"))).MovePageDialog
});
module.exports["MovePageDialog"] = $4f760397570928c6$export$28f6951b4656036e;

});

parcelRegister("3Fd01", function(module, exports) {

let $2aaf48d595b6cc98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2aaf48d595b6cc98$var$load("6wr18"),
    $2aaf48d595b6cc98$var$load("e4XZ1"),
    $2aaf48d595b6cc98$var$load("5ppK3"),
    $2aaf48d595b6cc98$var$load("7WcBh"),
    $2aaf48d595b6cc98$var$load("lVcuZ"),
    $2aaf48d595b6cc98$var$load("4mgLr"),
    $2aaf48d595b6cc98$var$load("lnnYm"),
    $2aaf48d595b6cc98$var$load("19uFC"),
    $2aaf48d595b6cc98$var$load("a4yJG"),
    $2aaf48d595b6cc98$var$load("2t3HP"),
    $2aaf48d595b6cc98$var$load("fzHDF"),
    $2aaf48d595b6cc98$var$load("5zDuS"),
    $2aaf48d595b6cc98$var$load("lUQAm"),
    $2aaf48d595b6cc98$var$load("7u4WP"),
    $2aaf48d595b6cc98$var$load("ffEVr"),
    $2aaf48d595b6cc98$var$load("Wowvf"),
    $2aaf48d595b6cc98$var$load("jlSv2"),
    $2aaf48d595b6cc98$var$load("1UUrt"),
    $2aaf48d595b6cc98$var$load("amUNi"),
    $2aaf48d595b6cc98$var$load("kWZnd"),
    $2aaf48d595b6cc98$var$load("92LGf"),
    $2aaf48d595b6cc98$var$load("2bmVk"),
    $2aaf48d595b6cc98$var$load("kUbUu"),
    $2aaf48d595b6cc98$var$load("7EorR"),
    $2aaf48d595b6cc98$var$load("hhss7"),
    $2aaf48d595b6cc98$var$load("h3ABO"),
    $2aaf48d595b6cc98$var$load("kC80R"),
    $2aaf48d595b6cc98$var$load("36rXN")
]).then(()=>parcelRequire('4yvcZ'));

});

parcelRegister("iff8m", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $2UWuP = parcelRequire("2UWuP");


var $hFGQl = parcelRequire("hFGQl");

const $d4855df5f39765b9$var$getAnalyticsData = (webItemId)=>{
    const fromName = webItemId === (0, $hFGQl.ANALYTICS_ADDON_BYLINE_ID) ? 'fromByline' : 'fromActionMenu';
    const event = {
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            source: 'viewPageScreen',
            actionSubject: 'AnalyticsButton',
            attributes: {
                from: fromName,
                type: 'viewers'
            }
        }
    };
    return event;
};
class $d4855df5f39765b9$export$9fe33c952d508e42 extends (0, $42omo.PureComponent) {
    render() {
        const { webItemId: webItemId } = this.props;
        const analyticsData = $d4855df5f39765b9$var$getAnalyticsData(webItemId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
            analyticsData: analyticsData
        }, this.props.children);
    }
}
$d4855df5f39765b9$export$9fe33c952d508e42.propTypes = {
    webItemId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node.isRequired
};
module.exports["AnalyticsPluginWrapper"] = $d4855df5f39765b9$export$9fe33c952d508e42;

});

parcelRegister("iVd6X", function(module, exports) {
var $fd8faec801601310$export$6c1ad2d761708c0b = /*#__PURE__*/ function(PublishPageAsBlogSources) {
    PublishPageAsBlogSources["ViewPage"] = "VIEW_PAGE";
    PublishPageAsBlogSources["EditPage"] = "EDIT_PAGE";
    return PublishPageAsBlogSources;
}({});
module.exports["PublishPageAsBlogSources"] = $fd8faec801601310$export$6c1ad2d761708c0b;

});

parcelRegister("6eFi0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ad336c78e6fcf61a$export$492577bc4a81367b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "seFL5",
    name: "ResolvedInlineCommentsDialogLoader",
    loader: async ()=>(await (parcelRequire("aXK9v"))).ResolvedInlineCommentsDialog
});
module.exports["ResolvedInlineCommentsDialogLoader"] = $ad336c78e6fcf61a$export$492577bc4a81367b;

});

parcelRegister("aXK9v", function(module, exports) {

let $7fb336ef66059c57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7fb336ef66059c57$var$load("fwmQF"),
    $7fb336ef66059c57$var$load("jwWp5"),
    $7fb336ef66059c57$var$load("4t77a"),
    $7fb336ef66059c57$var$load("3ySTn"),
    $7fb336ef66059c57$var$load("c2rHL"),
    $7fb336ef66059c57$var$load("jSdjl"),
    $7fb336ef66059c57$var$load("l2EUC"),
    $7fb336ef66059c57$var$load("6wr18"),
    $7fb336ef66059c57$var$load("89WyM"),
    $7fb336ef66059c57$var$load("1QdXB"),
    $7fb336ef66059c57$var$load("2t3HP"),
    $7fb336ef66059c57$var$load("1c1XO"),
    $7fb336ef66059c57$var$load("22RDk"),
    $7fb336ef66059c57$var$load("cPWI2"),
    $7fb336ef66059c57$var$load("h9Ed7"),
    $7fb336ef66059c57$var$load("lkOIY"),
    $7fb336ef66059c57$var$load("clQc9"),
    $7fb336ef66059c57$var$load("8PPsf"),
    $7fb336ef66059c57$var$load("1iUSs"),
    $7fb336ef66059c57$var$load("jbxHq"),
    $7fb336ef66059c57$var$load("5U3YO"),
    $7fb336ef66059c57$var$load("8YSo7"),
    $7fb336ef66059c57$var$load("gLGsg"),
    $7fb336ef66059c57$var$load("g9CVe"),
    $7fb336ef66059c57$var$load("5pvpJ"),
    $7fb336ef66059c57$var$load("amdBm"),
    $7fb336ef66059c57$var$load("Wowvf"),
    $7fb336ef66059c57$var$load("cyGuT"),
    $7fb336ef66059c57$var$load("hhss7"),
    $7fb336ef66059c57$var$load("lLssJ"),
    $7fb336ef66059c57$var$load("5aBKc"),
    $7fb336ef66059c57$var$load("jXx9i"),
    $7fb336ef66059c57$var$load("6kZfp"),
    $7fb336ef66059c57$var$load("2UbDA"),
    $7fb336ef66059c57$var$load("nbjnv"),
    $7fb336ef66059c57$var$load("flGQy"),
    $7fb336ef66059c57$var$load("jnsdM"),
    $7fb336ef66059c57$var$load("7u4WP"),
    $7fb336ef66059c57$var$load("am4CM"),
    $7fb336ef66059c57$var$load("ffEVr"),
    $7fb336ef66059c57$var$load("d6s42"),
    $7fb336ef66059c57$var$load("gZGoR"),
    $7fb336ef66059c57$var$load("jk2zg"),
    $7fb336ef66059c57$var$load("zjNVa"),
    $7fb336ef66059c57$var$load("75V2Q"),
    $7fb336ef66059c57$var$load("9IeAj"),
    $7fb336ef66059c57$var$load("6iKyY"),
    $7fb336ef66059c57$var$load("9iZkh"),
    $7fb336ef66059c57$var$load("8ublV"),
    $7fb336ef66059c57$var$load("e8XZq"),
    $7fb336ef66059c57$var$load("iBFHX"),
    $7fb336ef66059c57$var$load("hKZFn"),
    $7fb336ef66059c57$var$load("coTx0"),
    $7fb336ef66059c57$var$load("7EorR"),
    $7fb336ef66059c57$var$load("hOsjc")
]).then(()=>parcelRequire('92Mdh'));

});

parcelRegister("gLeLL", function(module, exports) {
/* SectionMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $j4WDj = parcelRequire("j4WDj");


var $4WmbV = parcelRequire("4WmbV");

const $103cc6a380e10ff8$export$a36903bd214cec06 = ({ children: children, withGradient: withGradient = true, topBanner: // TODO: refactor topBanner and customPadding per https://product-fabric.atlassian.net/browse/USD-337
// for now since we only support 2 different cases, we give a boolean, going forward, if more use cases surface, we can revisit and design a better API
topBanner = false, customPadding: customPadding, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($103cc6a380e10ff8$var$Layout, {
        withGradient: withGradient,
        topBanner: topBanner,
        customPadding: customPadding,
        "data-testid": "section-message"
    }, !!children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($103cc6a380e10ff8$var$ChildrenLayout, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true
    }));
const $103cc6a380e10ff8$var$ChildrenLayout = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx1ejb _p12f68cl _1ul968cl",
            __cmplp.className
        ])
    });
});
const $103cc6a380e10ff8$var$gradientBackground = `linear-gradient(84.09deg,
  ${(0, $j4WDj.GRADIENT_BACKGROUND_SUBTLEST_START)} 0%,
  ${(0, $j4WDj.GRADIENT_BACKGROUND_SUBTLEST_END)} 100%)`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $103cc6a380e10ff8$var$Layout = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withGradient: withGradient, customPadding: customPadding, topBanner: topBanner, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1p4ue13": (0, $7sObp.default)($103cc6a380e10ff8$var$gradientBackground),
            "--_krzptn": (0, $7sObp.default)((()=>{
                if (__cmplp.customPadding) return __cmplp.customPadding;
                if (__cmplp.topBanner) return `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"}`;
                return `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`;
            })())
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt41r3g _2rko12b0 _1e0c1txw _1bsb1osq _vchhusvi _kqswh2mm",
            __cmplp.withGradient ? "_11q7hu7i" : "_11q7glyw",
            __cmplp.className
        ])
    });
});
module.exports["SectionMessage"] = $103cc6a380e10ff8$export$a36903bd214cec06;

});

parcelRegister("4WmbV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $hArLp = parcelRequire("hArLp");

var $eEA8O = parcelRequire("eEA8O");


var $1ytiN = parcelRequire("1ytiN");


var $iJ9aA = parcelRequire("iJ9aA");


var $ki6F7 = parcelRequire("ki6F7");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");


var $lNKOh = parcelRequire("lNKOh");


var $bhvFb = parcelRequire("bhvFb");


var $9wGTI = parcelRequire("9wGTI");


var $cHKtk = parcelRequire("cHKtk");


var $kpYGL = parcelRequire("kpYGL");

var $3a454656eb0e87cd$export$d33a80488b9cab17 = /*#__PURE__*/ function(SectionMessageButtonConfig) {
    SectionMessageButtonConfig["DEFAULT"] = "default";
    SectionMessageButtonConfig["UPGRADE_ONLY"] = "upgradeOnly";
    SectionMessageButtonConfig["NONE"] = "none";
    return SectionMessageButtonConfig;
}({});
const $3a454656eb0e87cd$export$2e68cfab3dc25476 = ({ canShowUpgradeButton: canShowUpgradeButton = true, buttonConfig: buttonConfig = "default", upgradeEditionActionSubjectId: upgradeEditionActionSubjectId = 'freeTryNow', grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: showRequestUpgradeButton = false, showRequestUpgradeButtonAATest: showRequestUpgradeButtonAATest = false, isLoadingRequestUpgradeButton: isLoadingRequestUpgradeButton = false, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const CTAAnalyticsAttributes = (0, $42omo.useMemo)(()=>{
        return {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: Boolean(grandfathered)
        };
    }, [
        grandfathered,
        isSiteAdmin
    ]);
    const generateCTAAnalyticsProps = (actionSubjectId)=>({
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: CTAAnalyticsAttributes
        });
    const triggerLinkClickAnalytics = (clickEventActionSubjectId, linkMessage)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: clickEventActionSubjectId,
                source: source,
                attributes: {
                    ...CTAAnalyticsAttributes,
                    linkMessage: linkMessage
                }
            }
        }).fire();
    };
    const handleSecondaryLinkClick = ()=>{
        const link = secondaryLink;
        if (link) {
            triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
            if (typeof link.onClick === 'function') link.onClick();
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'changeEditionGatewayScreen',
                attributes: {
                    ...CTAAnalyticsAttributes,
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        CTAAnalyticsAttributes,
        source
    ]);
    const renderButtons = ()=>{
        if (isLoadingRequestUpgradeButton && (0, $9wGTI.fg)('connie_end_user_request_kill_switch')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "200px",
            height: "32px"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
            isSiteAdmin: isSiteAdmin,
            canShowUpgradeButton: canShowUpgradeButton,
            shouldShowLearnMore: !Boolean(secondaryLink),
            showRequestUpgradeButton: showRequestUpgradeButton
        }, ({ showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA })=>{
            //
            // primary
            //
            let primary;
            const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
                analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                ...props
            }) : null;
            if (upgradeEditionButton) primary = upgradeEditionButton;
            else if (showRequestUpgradeButton && (0, $9wGTI.fg)('connie_end_user_request_kill_switch')) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cHKtk.EndUserRequestUpgradeButton), {
                source: source
            });
            else if (showRequestUpgradeButtonAATest && (0, $9wGTI.fg)('connie_end_user_request_kill_switch')) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null);
            //
            // secondaries
            //
            let secondaries;
            if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                // If the 'Try it free/now' button is to be shown, but it is not the
                // primary CTA, then make sure its appearance is appropriate for a
                // secondary:
                if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(upgradeEditionButton, {
                        appearance: 'link'
                    })
                ];
                else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primary, secondaries);
        });
    };
    const getSecondaries = (showLearnMore, learnMoreIsPrimaryCTA)=>{
        const withIcon = Boolean(learnMoreLink?.icon);
        const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA ? learnMoreLink?.appearance || 'default' : 'link';
        const learnMoreButton = showLearnMore ? renderLearnMoreLink({
            appearance: learnMoreAppearance
        }) : null;
        const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            key: "secondLink",
            appearance: secondaryLink.appearance || 'default',
            href: secondaryLink.href ? secondaryLink.href : undefined,
            id: "secondaryLink",
            spacing: "default",
            target: secondaryLink.target || '_blank',
            onClick: handleSecondaryLinkClick,
            testId: (0, $k4Vdy.calculateTestId)({
                source: source,
                actionSubjectId: secondaryLink.actionSubjectId
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), secondaryLink.messageDescriptor)) : null;
        return secondaryLink?.appearance === 'primary' && learnMoreAppearance !== 'primary' ? [
            secondaryLinkComponent,
            learnMoreButton
        ] : [
            learnMoreButton,
            secondaryLinkComponent
        ];
    };
    const renderLearnMoreLink = ({ children: children, ...learnMoreProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ9aA.LearnMoreButton), {
            key: "learnMore",
            analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || 'freeLearnMore'),
            appearance: learnMoreLink?.appearance || 'default',
            onUpFlowOpen: onUpFlowOpen,
            targetEdition: targetEdition,
            inProductHelpId: learnMoreLink?.inProductHelpId,
            inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
            href: learnMoreLink?.href,
            icon: learnMoreLink?.icon,
            ariaLabel: learnMoreLink?.ariaLabel,
            ...learnMoreProps,
            onClick: learnMoreLink?.onClick
        }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), learnMoreLink.messageDescriptor) : undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhvFb.EditionSectionMessage), {
        actions: buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, renderButtons()) : undefined,
        edition: targetEdition,
        footer: isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, footer) : null,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, headerButton),
        ...props
    });
};
module.exports["SectionMessageButtonConfig"] = $3a454656eb0e87cd$export$d33a80488b9cab17;
module.exports["ChangeEditionSectionMessage"] = $3a454656eb0e87cd$export$2e68cfab3dc25476;

});

parcelRegister("lNKOh", function(module, exports) {
const $5ea77288491beecf$export$2321d4fb07b49d13 = ({ canShowUpgradeButton: canShowUpgradeButton, children: children, isSiteAdmin: isSiteAdmin, shouldShowLearnMore: shouldShowLearnMore = true, showRequestUpgradeButton: showRequestUpgradeButton })=>{
    let showUpgradeTryNowButton = false;
    let showLearnMore = true;
    let learnMoreIsPrimaryCTA = true;
    if (canShowUpgradeButton) {
        if (isSiteAdmin) showUpgradeTryNowButton = true;
        if (showUpgradeTryNowButton) {
            // NOTE: Don't show 'Learn More' CTA if it will appear in between the
            // Upgrade Edition button and a secondary feature link (like
            // "Remove this page's restrictions" button). In those cases, "Learn
            // More" CTA will be displayed at the end of the general text content,
            // outside of this component.
            showLearnMore = shouldShowLearnMore;
            learnMoreIsPrimaryCTA = false;
        }
    }
    if (showRequestUpgradeButton) // If an end user request upgrade button is present,
    // we don't show the learn more link if it's not specifically provided.
    showLearnMore = shouldShowLearnMore;
    return children({
        showUpgradeTryNowButton: showUpgradeTryNowButton,
        showLearnMore: showLearnMore,
        learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA
    });
};
module.exports["ChangeEditionSectionMessageButtonsWrapper"] = $5ea77288491beecf$export$2321d4fb07b49d13;

});

parcelRegister("bEpHb", function(module, exports) {

let $87b75cbe1b7bd15d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $87b75cbe1b7bd15d$var$load("momKe").then(()=>parcelRequire('csnLw'));

});

parcelRegister("f0NfR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");

function $b5f8b5d5e877d1bc$export$86eb994f9cd7d13a(WrappedComponent) {
    function WithSessionData(props) {
        const sessionData = (0, $bQm3c.useSessionData)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            sessionData: sessionData,
            ...props
        });
    }
    WithSessionData.displayName = `withSessionData(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithSessionData;
}
module.exports["withSessionData"] = $b5f8b5d5e877d1bc$export$86eb994f9cd7d13a;

});

parcelRegister("kxhju", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $iEfsZ = parcelRequire("iEfsZ");


var $42omo = parcelRequire("42omo");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $gTyTP = parcelRequire("gTyTP");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $42omo.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch, isLiveDocsEnabled: isLiveDocsEnabled } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            if (isLiveDocsEnabled) webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    let t0;
    if ($[0] !== isLivePagesFeatureEnabled || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, {
            ...props,
            isLiveDocsEnabled: isLivePagesFeatureEnabled
        });
        $[0] = isLivePagesFeatureEnabled;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, {
        ...props,
        isLiveDocsEnabled: isLivePagesFeatureEnabled
    });
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<fc3f514c1b8fc23b442bac6c90faf10b>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("bavCP", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");

function $86f32d96feea2a1f$export$67f105fad14d18d({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
}
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("1gjU5", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw140y _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw140y _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ])
    });
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("3QyBm", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $4VJDS.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("78wUU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $745e4e253bb54f50$export$fbea3c6f057d30b6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "epAoB",
    name: "MoveBlogModalLoader",
    loader: async ()=>(await (parcelRequire("1XBTi"))).MoveBlogModal
});
module.exports["MoveBlogModalLoader"] = $745e4e253bb54f50$export$fbea3c6f057d30b6;

});

parcelRegister("1XBTi", function(module, exports) {

let $16d8b177b3877728$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $16d8b177b3877728$var$load("6wr18"),
    $16d8b177b3877728$var$load("lnnYm"),
    $16d8b177b3877728$var$load("ffEVr"),
    $16d8b177b3877728$var$load("Wowvf"),
    $16d8b177b3877728$var$load("hhss7"),
    $16d8b177b3877728$var$load("aoUod")
]).then(()=>parcelRequire('fzGQR'));

});

parcelRegister("cQhbe", function(module, exports) {
var $3ddd96eb421fb45c$export$c184dc244f9dacf4 = /*#__PURE__*/ function(AutoConvertEvent) {
    AutoConvertEvent["VIEWED"] = "pageViewed";
    AutoConvertEvent["EDITED"] = "pageEdited";
    AutoConvertEvent["PUBLISHED"] = "pagePublished";
    AutoConvertEvent["NOTIFICATION_SHOWN"] = "notificationShown";
    AutoConvertEvent["NOTIFICATION_ERROR"] = "notificationError";
    return AutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$a248ed70ead7ff08 = /*#__PURE__*/ function(AutoConvertActionSubject) {
    AutoConvertActionSubject["AUTO_CONVERSION"] = "autoConversion";
    AutoConvertActionSubject["AUTO_CONVERSION_BYLINE"] = "autoConversionByLine";
    return AutoConvertActionSubject;
}({});
var $3ddd96eb421fb45c$export$d8b435b7aa875953 = /*#__PURE__*/ function(RevertAutoConvertEvent) {
    RevertAutoConvertEvent["DIALOG_OPEN"] = "revertDialogOpen";
    RevertAutoConvertEvent["CLICKED"] = "revertClicked";
    RevertAutoConvertEvent["CANCELLED"] = "revertCancelled";
    RevertAutoConvertEvent["CONFIRMED"] = "revertConfirmed";
    RevertAutoConvertEvent["ERROR"] = "revertError";
    return RevertAutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$b22548c36d783030 = /*#__PURE__*/ function(AutoConvertPanelEvent) {
    AutoConvertPanelEvent["VIEWED"] = "panelViewed";
    AutoConvertPanelEvent["SUPPORTED"] = "panelSupported";
    AutoConvertPanelEvent["NONE"] = "panelNone";
    AutoConvertPanelEvent["GET_ERROR"] = "panelGetError";
    AutoConvertPanelEvent["SET_ERROR"] = "panelSetError";
    return AutoConvertPanelEvent;
}({});
var $3ddd96eb421fb45c$export$e8dbd545dc7c3af0 = /*#__PURE__*/ function(AutoConversionByLineEvent) {
    AutoConversionByLineEvent["CLICKED"] = "bylineClicked";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_OPENED"] = "newEditorModalOpened";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_CLOSED"] = "newEditorModalClosed";
    return AutoConversionByLineEvent;
}({});
const $3ddd96eb421fb45c$export$b4535793cfa6d80a = (createAnalyticsEvent, analytics, actionSubject)=>{
    const { pageAction: pageAction, source: source, setting: setting } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'triggered',
            actionSubject: actionSubject,
            source: source,
            actionSubjectId: 'page',
            attributes: {
                pageAction: pageAction,
                setting: setting
            }
        }
    }).fire();
};
const $3ddd96eb421fb45c$export$e045315387fc4262 = (createAnalyticsEvent, analytics)=>{
    const { level: level, panelAction: panelAction, source: source } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'autoConversion',
            source: source,
            actionSubjectId: 'panel',
            attributes: {
                level: level,
                panelAction: panelAction
            }
        }
    }).fire();
};
module.exports["AutoConvertEvent"] = $3ddd96eb421fb45c$export$c184dc244f9dacf4;
module.exports["AutoConvertActionSubject"] = $3ddd96eb421fb45c$export$a248ed70ead7ff08;
module.exports["RevertAutoConvertEvent"] = $3ddd96eb421fb45c$export$d8b435b7aa875953;
module.exports["AutoConvertPanelEvent"] = $3ddd96eb421fb45c$export$b22548c36d783030;
module.exports["AutoConversionByLineEvent"] = $3ddd96eb421fb45c$export$e8dbd545dc7c3af0;
module.exports["sendEditorConversionAnalyticsPageEvent"] = $3ddd96eb421fb45c$export$b4535793cfa6d80a;
module.exports["sendEditorConversionAnalyticsPanelEvent"] = $3ddd96eb421fb45c$export$e045315387fc4262;

});

parcelRegister("jcM8h", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $j1Ss3 = parcelRequire("j1Ss3");


var $6R5uz = parcelRequire("6R5uz");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $dAYOx = parcelRequire("dAYOx");


var $lGgRw = parcelRequire("lGgRw");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $a6t12 = parcelRequire("a6t12");


var $68BwE = parcelRequire("68BwE");


var $jFm04 = parcelRequire("jFm04");


var $3SLf9 = parcelRequire("3SLf9");

const $a26c936fb563039b$var$i18n = (0, $cgtv4.defineMessages)({
    creator: {
        id: "content-ownership.content-owner-popup.creator",
        defaultMessage: "<b>Creator</b>"
    },
    owner: {
        id: "content-ownership.content-owner-popup.owner",
        defaultMessage: "<b>Owner</b>"
    },
    changeOwner: {
        id: "content-ownership.content-owner-popup.change-owner",
        defaultMessage: "Change owner"
    },
    ariaLabel: {
        id: "content-ownership.content-owner-popup.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
// fixed dimensions
const $a26c936fb563039b$var$contentOwnerContainerStyles = (0, $ecnYn.xcss)({
    width: '232px',
    height: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerViewerContainerStyles = (0, $ecnYn.xcss)({
    width: '232px',
    height: '140px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentCreatorItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerChangeItemStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerNameItemStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.025',
    textDecoration: 'underline',
    color: 'color.text',
    ':hover': {
        color: 'color.link',
        cursor: 'pointer'
    }
});
const $a26c936fb563039b$var$ContentOwnerDetailsPanelName = ({ userId: userId, fullName: fullName, ariaLabel: ariaLabel })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerNameItemStyles,
        role: "tooltip",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: userId,
        position: "left-start",
        offset: [
            0,
            28
        ],
        fullName: fullName
    }, fullName));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanel = ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, openModal: openModal, setInitialFocusRef: setInitialFocusRef })=>{
    const intl = (0, $8C5kA.default)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    const onClickChangeOwner = (0, $42omo.useCallback)(()=>{
        openModal();
        closePopup();
        experienceTracker.start({
            name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
        });
    }, [
        closePopup,
        openModal,
        experienceTracker
    ]);
    const isAllowedToChange = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedBy.userId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            isAllowedToChange ? $a26c936fb563039b$var$contentOwnerContainerStyles : $a26c936fb563039b$var$contentOwnerViewerContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentCreatorItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$a26c936fb563039b$var$i18n.creator,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: createdBy.userId,
        fullName: createdBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: createdBy.fullName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$a26c936fb563039b$var$i18n.owner,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: ownedBy.userId,
        fullName: ownedBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: ownedBy.fullName
        })
    })), isAllowedToChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerChangeItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: onClickChangeOwner,
        appearance: "link",
        spacing: "none",
        ref: setInitialFocusRef
    }, intl.formatMessage($a26c936fb563039b$var$i18n.changeOwner))));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper = ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, setInitialFocusRef: setInitialFocusRef })=>{
    if (!ownedBy || !createdBy) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, ({ openModal: openModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanel, {
            ownedBy: ownedBy,
            createdBy: createdBy,
            closePopup: closePopup,
            openModal: openModal,
            setInitialFocusRef: setInitialFocusRef
        }));
};
const $a26c936fb563039b$export$62380b37452323f8 = ({ contentId: contentId, itemId: itemId, itemLabel: itemLabel, isOpen: isOpen, onClick: onClick, onCloseParent: onCloseParent, onClosePopup: onClosePopup, onMouseEnter: onMouseEnter, elemBefore: elemBefore })=>{
    const closeOwnerDialog = ()=>{
        onClosePopup();
        onCloseParent?.();
    };
    const { data: ownerHistoryData } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query ContentOwnerPopupComponentContentOwnerQuery($contentId:ID!){singleContent(id:$contentId){id history{createdBy{displayName ...on KnownUser{accountId}}ownedBy{displayName ...on KnownUser{accountId}}}}}`, {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    });
    const toUserData = (user)=>({
            userId: user?.accountId ?? undefined,
            fullName: user?.displayName,
            isAnonymous: !user?.accountId
        });
    const ownedBy = toUserData(ownerHistoryData?.singleContent?.history?.ownedBy);
    const createdBy = toUserData(ownerHistoryData?.singleContent?.history?.createdBy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        key: `container-${itemId}`,
        isOpen: isOpen,
        onClose: onClosePopup,
        // @ts-ignore onBlur not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
        onBlur: onClosePopup,
        placement: "left-start",
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closeOwnerDialog,
                setInitialFocusRef: setInitialFocusRef
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                elemBefore: elemBefore,
                ...triggerProps,
                onClick: onClick,
                // @ts-ignore onMouseEnter not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
                onMouseEnter: onMouseEnter,
                isSelected: isOpen,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, itemLabel)),
        shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truepage-experie')
    });
};
module.exports["ContentOwnerPopupComponent"] = $a26c936fb563039b$export$62380b37452323f8;

});

parcelRegister("1Zthr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $86e4d9c8583d266f$export$9c05e92142f10f44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CxVtX",
    name: "UnarchivePagesDialogLoader",
    loader: async ()=>(await (parcelRequire("aWQfF"))).UnarchivePagesLoader
});
module.exports["UnarchivePagesDialogLoader"] = $86e4d9c8583d266f$export$9c05e92142f10f44;

});

parcelRegister("aWQfF", function(module, exports) {

let $7f87da4632ab4a79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f87da4632ab4a79$var$load("kHOMt"),
    $7f87da4632ab4a79$var$load("6kZfp"),
    $7f87da4632ab4a79$var$load("2UbDA"),
    $7f87da4632ab4a79$var$load("zjNVa"),
    $7f87da4632ab4a79$var$load("6wr18"),
    $7f87da4632ab4a79$var$load("1u9sS"),
    $7f87da4632ab4a79$var$load("kH8lz"),
    $7f87da4632ab4a79$var$load("7WcBh"),
    $7f87da4632ab4a79$var$load("iQ0Jm"),
    $7f87da4632ab4a79$var$load("Wowvf"),
    $7f87da4632ab4a79$var$load("ffEVr"),
    $7f87da4632ab4a79$var$load("hhss7"),
    $7f87da4632ab4a79$var$load("jXx9i"),
    $7f87da4632ab4a79$var$load("nbjnv"),
    $7f87da4632ab4a79$var$load("7u4WP"),
    $7f87da4632ab4a79$var$load("dxDVc")
]).then(()=>parcelRequire('ew61I'));

});

parcelRegister("k22lL", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1988df8ccc55d194$export$8cf79fbd47bc14c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wym_j",
    name: "ArchiveUpsellDialog",
    loader: async ()=>(await (parcelRequire("7hrv1"))).ArchiveUpsellDialog
});
module.exports["ArchiveUpsellDialog"] = $1988df8ccc55d194$export$8cf79fbd47bc14c3;

});

parcelRegister("7hrv1", function(module, exports) {

let $54cf73c1464cd055$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $54cf73c1464cd055$var$load("fD0v8"),
    $54cf73c1464cd055$var$load("hhss7"),
    $54cf73c1464cd055$var$load("cPaXL")
]).then(()=>parcelRequire('v2hhG'));

});

parcelRegister("2WH1B", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2099f9ed78e06b67$export$baebba9f0bb9158 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ptN9P",
    name: "ArchivePagesLoader",
    loader: async ()=>(await (parcelRequire("kpl9f"))).ArchivePagesLoader
});
module.exports["ArchivePagesLoader"] = $2099f9ed78e06b67$export$baebba9f0bb9158;

});

parcelRegister("kpl9f", function(module, exports) {

let $edb68c03d219e1b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $edb68c03d219e1b3$var$load("6kZfp"),
    $edb68c03d219e1b3$var$load("2UbDA"),
    $edb68c03d219e1b3$var$load("zjNVa"),
    $edb68c03d219e1b3$var$load("6wr18"),
    $edb68c03d219e1b3$var$load("1u9sS"),
    $edb68c03d219e1b3$var$load("kH8lz"),
    $edb68c03d219e1b3$var$load("iQ0Jm"),
    $edb68c03d219e1b3$var$load("ffEVr"),
    $edb68c03d219e1b3$var$load("Wowvf"),
    $edb68c03d219e1b3$var$load("kHOMt"),
    $edb68c03d219e1b3$var$load("jXx9i"),
    $edb68c03d219e1b3$var$load("nbjnv"),
    $edb68c03d219e1b3$var$load("9ftJe"),
    $edb68c03d219e1b3$var$load("hhss7"),
    $edb68c03d219e1b3$var$load("3uux1")
]).then(()=>parcelRequire('iYH6z'));

});

parcelRegister("5gFHQ", function(module, exports) {

var $6MJBu = parcelRequire("6MJBu");

const $55ad5daf9125a00c$export$a005804086228029 = (operations)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($6MJBu)))(operations, {
        targetType: 'page',
        operation: 'archive'
    });
};
const $55ad5daf9125a00c$export$3c5f398ac6d45bea = (operations)=>(0, (/*@__PURE__*/$parcel$interopDefault($6MJBu)))(operations, {
        targetType: 'page',
        operation: 'delete'
    });
module.exports["canUnarchivePage"] = $55ad5daf9125a00c$export$a005804086228029;

});

parcelRegister("6MJBu", function(module, exports) {

var $eZD4P = parcelRequire("eZD4P");


var $hWvFC = parcelRequire("hWvFC");


var $am9PL = parcelRequire("am9PL");


var $fZxmY = parcelRequire("fZxmY");


var $4U5Tv = parcelRequire("4U5Tv");

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $4f0a99bac1caa29c$var$some(collection, predicate, guard) {
    var func = $fZxmY(collection) ? $eZD4P : $am9PL;
    if (guard && $4U5Tv(collection, predicate, guard)) predicate = undefined;
    return func(collection, $hWvFC(predicate, 3));
}
module.exports = $4f0a99bac1caa29c$var$some;

});

parcelRegister("am9PL", function(module, exports) {

var $iawSg = parcelRequire("iawSg");

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $78a3963f19073cd4$var$baseSome(collection, predicate) {
    var result;
    $iawSg(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $78a3963f19073cd4$var$baseSome;

});

parcelRegister("31PvZ", function(module, exports) {
const $08262a857a2c6c3b$export$53f8d97172a58cb1 = 'action-remove-content-link';
const $08262a857a2c6c3b$export$2fb29548e6de5956 = 'action-move-blogpost-dialog-link';
const $08262a857a2c6c3b$export$7f09563bf7a05b2 = 'action-downgrade-to-tiny';
const $08262a857a2c6c3b$export$b624357a7e412922 = 'action-copy-page-link';
const $08262a857a2c6c3b$export$4d779c09dd0862f3 = 'action-move-page-dialog-link';
const $08262a857a2c6c3b$export$49ff63079484e0bb = 'action-archive-link';
const $08262a857a2c6c3b$export$b6b632389689b250 = 'action-edit-embed-modal';
const $08262a857a2c6c3b$export$d1d9e5a82ffdf347 = 'action-view-history-link';
const $08262a857a2c6c3b$export$a260c41316710423 = 'bm-resolved-inline-comments';
module.exports["DELETE_PAGE_LINK"] = $08262a857a2c6c3b$export$53f8d97172a58cb1;
module.exports["ACTION_MOVE_BLOG_DIALOG"] = $08262a857a2c6c3b$export$2fb29548e6de5956;
module.exports["REVERT_EDITOR_LINK"] = $08262a857a2c6c3b$export$7f09563bf7a05b2;
module.exports["PAGE_HISTORY_LINK"] = $08262a857a2c6c3b$export$d1d9e5a82ffdf347;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedToggle: $d24b02c281555a47$var$ChoreographerComponentStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("6oZiN", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $jhwJP = parcelRequire("jhwJP");

const $fd94ae0dd1a4bd51$var$i18nBase = (0, $cgtv4.defineMessages)({
    title: {
        id: "page-recommendations.eop.title",
        defaultMessage: "Related content"
    },
    feedback: {
        id: "page-recommendations.eop.feedback.button",
        defaultMessage: "Give feedback"
    },
    info: {
        id: "page-recommendations.eop.feedback.info",
        defaultMessage: "These suggestions are automatically generated based on content that is viewed or organized together. Suggestions update over time and respect content restrictions."
    },
    hide: {
        id: "page-recommendations.eop.feedback.hide",
        defaultMessage: "Hide for everyone..."
    },
    modal_title: {
        id: "page-recommendations.eop.hide.modal.title",
        defaultMessage: "Hide related content for <b>everyone</b>?"
    },
    modal_cancel: {
        id: "page-recommendations.eop.hide.modal.cancel",
        defaultMessage: "Cancel"
    },
    modal_hide: {
        id: "page-recommendations.eop.hide.modal.hide.button",
        defaultMessage: "Hide for everyone"
    },
    modal_info: {
        id: "page-recommendations.eop.hide.modal.info",
        defaultMessage: "Suggestions for this content will be hidden from everyone."
    },
    modal_info_show: {
        id: "page-recommendations.eop.hide.modal.info.show",
        defaultMessage: "You can show related content again under advanced details."
    },
    space_setting_info: {
        id: "page-recommendations.eop.space.setting.info",
        defaultMessage: "Related content automatically generates suggestions based on content viewed or organized together. These will appear as a series of cards at the bottom of some pages, and may update over time."
    },
    space_setting_hide_toggle: {
        id: "page-recommendations.eop.space.setting.hide.toggle",
        defaultMessage: "Related content"
    },
    space_setting_default: {
        id: "page-recommendations.eop.space.setting.default",
        defaultMessage: "Default behavior"
    },
    space_setting_hidden: {
        id: "page-recommendations.eop.space.setting.default.hidden",
        defaultMessage: "Hidden on each page"
    },
    space_setting_shown: {
        id: "page-recommendations.eop.space.setting.default.shown",
        defaultMessage: "Shown on each page"
    },
    feedbackMessage: {
        id: "page-recommendations.related.pages.space.settings.feedback.section",
        defaultMessage: "What do you think of related content?"
    },
    feedbackButtonText: {
        id: "page-recommendations.related.pages.space.settings.feedback.button.text",
        defaultMessage: "Give feedback"
    },
    feedbackTitle: {
        id: "page-recommendations.feedback.title.v2",
        defaultMessage: "Thank you for trying out related content"
    },
    feedbackDescription: {
        id: "page-recommendations.feedback.description",
        defaultMessage: "How satisfied are you with related content?"
    },
    feedbackFollowup: {
        id: "page-recommendations.feedback.followup",
        defaultMessage: "Thanks for the feedback! What do you like about it? What could be improved?"
    },
    feedbackSecondFollowup: {
        id: "page-recommendations.feedback.followup.second",
        defaultMessage: "Any feedback on related content for this specific item?"
    },
    feedbackConfirmation: {
        id: "page-recommendations.feedback.confirmation",
        defaultMessage: "Feedback submitted"
    },
    feedbackConfirmationDescription: {
        id: "page-recommendations.feedback.confirmation.description.v2",
        defaultMessage: "Thank you for helping us improve related content!"
    },
    feedbackSubmit: {
        id: "page-recommendations.feedback.submit",
        defaultMessage: "Submit"
    },
    feedbackCancel: {
        id: "page-recommendations.feedback.cancel",
        defaultMessage: "Cancel"
    },
    terrible: {
        id: "page-recommendations.feedback.rating.terrible",
        defaultMessage: "terrible"
    },
    bad: {
        id: "page-recommendations.feedback.rating.bad",
        defaultMessage: "bad"
    },
    okay: {
        id: "page-recommendations.feedback.rating.okay",
        defaultMessage: "okay"
    },
    good: {
        id: "page-recommendations.feedback.rating.good",
        defaultMessage: "good"
    },
    great: {
        id: "page-recommendations.feedback.rating.great",
        defaultMessage: "great"
    },
    expandButton: {
        id: "page-recommendations.eop.expand.button",
        defaultMessage: "Expand"
    },
    collapseButton: {
        id: "page-recommendations.eop.collapse.button",
        defaultMessage: "Collapse"
    },
    infoButton: {
        id: "page-recommendations.eop.info",
        defaultMessage: "More info"
    },
    adminConfigFeedbackTitle: {
        id: "page-recommendations.admin-config.feedback.title",
        defaultMessage: "Help us improve Confluence"
    },
    adminConfigFeedbackSummaryPlaceholder: {
        id: "page-recommendations.admin-config.feedback.summary.placeholder",
        defaultMessage: "What did we do well? What could be improved?"
    }
});
const $fd94ae0dd1a4bd51$var$i18nLiveDocs = (0, $cgtv4.defineMessages)({
    space_setting_hidden: {
        id: "page-recommendations.eop.space.setting.default.hidden.livedocs",
        defaultMessage: "Hidden on each page or live doc"
    },
    space_setting_shown: {
        id: "page-recommendations.eop.space.setting.default.shown.livedocs",
        defaultMessage: "Shown on each page or live doc"
    }
});
const $fd94ae0dd1a4bd51$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($fd94ae0dd1a4bd51$var$i18nBase, $fd94ae0dd1a4bd51$var$i18nLiveDocs);
module.exports["i18n"] = $fd94ae0dd1a4bd51$export$a7357cdd1f0b0168;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("4XcQZ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $dcd0924fd6cc7ace$export$d322defea4af96d5 = (0, $eSUdr.default)`query EndOfPageRecommendationQuery($type:String!$id:ID!$exp:String!$key:ID!$keyString:String!){space(key:$keyString){id}getRecommendedPages(entityType:$type entityId:$id experience:$exp){recommendedPages{content{id title type subType creatorId links{webui}history{ownedBy{displayName}}space{id key name}emoji:properties(key:"emoji-title-published"){nodes{id key value}}}strategy}status{userCanToggle isEnabled}}getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled defaultBehavior}}`;
module.exports["EndOfPageRecommendationQuery"] = $dcd0924fd6cc7ace$export$d322defea4af96d5;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["VIEW_AI_PRESENTATION_INTERACTION"] = $4fa41f80373a2ebe$export$af1eb8557193d022;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("fV9S6", function(module, exports) {

let $b973d6343d2f696d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b973d6343d2f696d$var$load("hRE4a").then(()=>parcelRequire('d4y8J'));

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    visitedLink: "_ect41gqc _10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)(appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    object = $9rfkh(object, path);
    return object == null || delete object[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("lyWac", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");

function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return Promise.allSettled(values).then((results)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            const errors = [];
            for (const result of results){
                if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
                else if (result.status === 'fulfilled') {
                    const fulfilledValue = result.value;
                    if (fulfilledValue instanceof Error) errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue));
                    else if (Array.isArray(fulfilledValue)) {
                        const filteredErrors = fulfilledValue.filter((value)=>value instanceof Error);
                        errors.push(...filteredErrors.flatMap($6e8f7926b945fe5e$var$expandErrorToErrors));
                    }
                }
            }
            if (errors.length > 0) {
                // Errors on preloader functions are not meant to break anything.
                // But we still want to know them...
                // eslint-disable-next-line no-console
                console.error('Errors caught by waitForAllReturnWhenError', {
                    errors: errors.map((error)=>error.message)
                });
                return errors;
            }
        });
    })();
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("9sGCn", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ge2sX = parcelRequire("ge2sX");


var $9p0fU = parcelRequire("9p0fU");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeAndStatusFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $9p0fU.PTPageSubTypeFragment)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $9p0fU.SearchConfluencePageBlogAttachmentSubTypeFragment)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    const ccGqlClient = (0, $hp2SH.getApolloClient)();
    const aggGqlClient = (0, $gKr8t.getAGGClient)();
    const clientMap = {
        ["Cc graphql client"]: ccGqlClient,
        ["Agg graphql client"]: aggGqlClient
    };
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            // This approach is duplicated in /confluence/next/packages/editor-features/src/utils/getCachedPageTitle.ts
            // and should be migrated to readFragmentInterop.
            const fragmentData = clientMap[client].readFragment({
                id: id,
                fragment: fragment
            });
            if (fragmentData?.subType) {
                subType = fragmentData.subType;
                isArchived = fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData?.confluenceEntity?.subtype) {
                // In search graphql query's response, subtype exists in the confluenceEntity object
                subType = fragmentData.confluenceEntity.subtype.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("9p0fU", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f3357fc24ccca23a$export$6345dfb10a0b6cbe = (0, $eSUdr.default)`fragment SubTypeAndStatusContentFragment on Content{id subType status}`;
const $f3357fc24ccca23a$export$4121dd5434380612 = (0, $eSUdr.default)`fragment SubTypeContentFragment on Content{id subType}`;
const $f3357fc24ccca23a$export$e7df79006c7c4a55 = (0, $eSUdr.default)`fragment SubTypePageTreeFragment on PTPage{id subType}`;
const $f3357fc24ccca23a$export$e77fa03b04da6df0 = (0, $eSUdr.default)`fragment SubTypeFragment on SearchConfluencePageBlogAttachment{id confluenceEntity{subtype}}`;
module.exports["ContentSubTypeAndStatusFragment"] = $f3357fc24ccca23a$export$6345dfb10a0b6cbe;
module.exports["ContentSubTypeFragment"] = $f3357fc24ccca23a$export$4121dd5434380612;
module.exports["PTPageSubTypeFragment"] = $f3357fc24ccca23a$export$e7df79006c7c4a55;
module.exports["SearchConfluencePageBlogAttachmentSubTypeFragment"] = $f3357fc24ccca23a$export$e77fa03b04da6df0;

});

parcelRegister("6LsQQ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $g2gGv = parcelRequire("g2gGv");

const $f8780459a3f4abf6$export$7da3cd10eb68919e = (0, $eSUdr.default)`query ContentTypesHeaderQuery($contentId:ID$useObjectHeader:Boolean!){content(id:$contentId status:["archived" "current" "draft"]){nodes{id title operations{operation targetType}space{id name key alias}type subType status version@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedVersionFragment}draftVersion@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedDraftVersionFragment}}}}${(0, $g2gGv.LastEditedVersionFragment)}${(0, $g2gGv.LastEditedDraftVersionFragment)}`;
module.exports["ContentTypesHeaderQuery"] = $f8780459a3f4abf6$export$7da3cd10eb68919e;

});

parcelRegister("g2gGv", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $82f60ea6bd1b627b$export$deecf62d8ca1b922 = (0, $eSUdr.default)`fragment LastEditedVersionFragment on Version{by{displayName}when}`;
const $82f60ea6bd1b627b$export$36bc043d85f07c8 = (0, $eSUdr.default)`fragment LastEditedDraftVersionFragment on Version{by{displayName}when}`;
module.exports["LastEditedVersionFragment"] = $82f60ea6bd1b627b$export$deecf62d8ca1b922;
module.exports["LastEditedDraftVersionFragment"] = $82f60ea6bd1b627b$export$36bc043d85f07c8;

});

parcelRegister("fyUox", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $1Y111 = parcelRequire("1Y111");


var $zalpJ = parcelRequire("zalpJ");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.query)({
            query: (0, $zalpJ.PreloadHomepageIdQuery),
            variables: {
                spaceKey: spaceKey
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $1Y111.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9o4Fw = parcelRequire("9o4Fw");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $9o4Fw.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("alaek", function(module, exports) {
$parcel$export(module.exports, "default", () => $21bae01687242d76$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $6fnsQ = parcelRequire("6fnsQ");


var $cmDjE = parcelRequire("cmDjE");

const $21bae01687242d76$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`;
const $21bae01687242d76$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $6fnsQ.N90)})`;
function $21bae01687242d76$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cmDjE.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        })
    });
}

});

parcelRegister("cmDjE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5P3yi = parcelRequire("5P3yi");


var $f2BEc = parcelRequire("f2BEc");

const $bdf91181004cdb95$var$boxShadowCssVar = '--avatar-box-shadow';
const $bdf91181004cdb95$var$bgColorCssVar = '--avatar-bg-color'; /**
                                            * We need to maintan the container styles manually until Avatar provides the correct border radius.
                                            * After that we can return to wrapping in <AvatarContent> rather than span
                                            */ 
const $bdf91181004cdb95$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw",
    nonCompactSpacing: "_6rthv77o _1pfhv77o _12l2v77o _ahbqv77o",
    compactSpacing: "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $bdf91181004cdb95$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y"
};
const $bdf91181004cdb95$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $bdf91181004cdb95$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $bdf91181004cdb95$var$borderRadiusMap = {
    xsmall: "_2rkol0p1",
    small: "_2rkol0p1",
    medium: "_2rkol0p1",
    large: "_2rkol0p1",
    xlarge: "_2rkol0p1",
    xxlarge: "_2rkol0p1"
};
const $bdf91181004cdb95$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
}; /**
    * __Avatar image__
    *
    * An avatar image is an internal component used to control the rendering phases of an image.
    */ 
const $bdf91181004cdb95$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId, compact: compact = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false);
    const avatarSrc = (0, $f2BEc.getTeamAvatarSrc)(src, teamId); // If src changes, reset state
    (0, $42omo.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if (!avatarSrc || hasImageErrored) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5P3yi.FallbackAvatar), {
        "aria-label": alt,
        width: $bdf91181004cdb95$var$SIZES[size],
        height: $bdf91181004cdb95$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $gMc0m.default)([
            $bdf91181004cdb95$var$unboundStyles.root,
            $bdf91181004cdb95$var$containerStyles.root,
            $bdf91181004cdb95$var$borderRadiusMap[size],
            $bdf91181004cdb95$var$widthHeightMap[size],
            compact ? $bdf91181004cdb95$var$containerStyles.compactSpacing : $bdf91181004cdb95$var$containerStyles.nonCompactSpacing
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $gMc0m.default)([
                $bdf91181004cdb95$var$avatarImageStyles.image
            ])
        })
    });
};
module.exports["TeamAvatarImage"] = $bdf91181004cdb95$export$ac3673635a5387be;

});

parcelRegister("5P3yi", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $2cfa1b514c8db58a$var$styles = {
    wrapper: "_1e0c1txw",
    wrapperSpacing: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    compactWrapperSpacing: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t"
};
function $2cfa1b514c8db58a$export$eb63dcc490f6bbcd({ compact: compact, ...props }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($2cfa1b514c8db58a$var$styles.wrapper, compact ? $2cfa1b514c8db58a$var$styles.compactWrapperSpacing : $2cfa1b514c8db58a$var$styles.wrapperSpacing),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}
module.exports["FallbackAvatar"] = $2cfa1b514c8db58a$export$eb63dcc490f6bbcd;

});

parcelRegister("f2BEc", function(module, exports) {
/**
 * If a src value is given, we'll use that directly.
 * Otherwise we'll generate a static URL from the teamId.
 * If neither are provided, return undefined so that the fallback will be used.
 */ function $e75bf44959780d0d$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return undefined;
}
module.exports["getTeamAvatarSrc"] = $e75bf44959780d0d$export$59ff7d19feb890b6;

});

parcelRegister("jv3O2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $jhwJP = parcelRequire("jhwJP");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");

const $a23dc1f066cda204$var$i18nBase = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle",
        defaultMessage: "This page was switched to a live page"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle",
        defaultMessage: "You\u2019ve switched to a live page"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody",
        defaultMessage: "Updates to this page will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore",
        defaultMessage: "Find out more"
    },
    reloadButton: {
        id: "editor-flags.convert-to-live-page-flag.reloadButton",
        defaultMessage: "Reload"
    }
});
const $a23dc1f066cda204$var$i18nLiveDocs = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle.livedocs",
        defaultMessage: "This page was converted to a live doc"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle.livedocs",
        defaultMessage: "You\u2019ve converted to a live doc"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody.livedocs",
        defaultMessage: "Updates to this doc will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore.livedocs",
        defaultMessage: "Find out more about live docs"
    }
});
const $a23dc1f066cda204$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($a23dc1f066cda204$var$i18nBase, $a23dc1f066cda204$var$i18nLiveDocs);
const $a23dc1f066cda204$var$LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME = 11000;
const $a23dc1f066cda204$export$cb5a789d90de377 = ({ flags: flags })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const intl = (0, $8C5kA.default)();
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const handleOnClick = (0, $42omo.useCallback)(()=>{
        const livePageLink = (0, $1NBp8.VIEW_PAGE).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        });
        return isOnEditRoute ? replace(livePageLink) : window.location.reload();
    }, [
        isOnEditRoute,
        replace,
        spaceKey,
        contentId
    ]);
    return (0, $42omo.useCallback)(async ({ converterWasCurrentUser: converterWasCurrentUser })=>{
        const successFlag = await flags.showFlag({
            title: converterWasCurrentUser ? intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.switcherFlagTitle) : intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagTitle),
            description: intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagBody),
            type: 'success',
            id: 'convert-to-live-page-flag',
            close: 'never',
            // Needed to bypass the flags.hideAllFlags() call in EditorFlags.tsx on editor unmount.
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                        "data-testid": "reload-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.reloadButton)),
                    onClick: handleOnClick
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                        "data-testid": "find-out-more-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.findOutMore)),
                    onClick: ()=>window.open($a23dc1f066cda204$var$LEARN_MORE_URL, '_blank')
                }
            ]
        });
        // We don't want to auto-close the flag when a different user converts the page,
        // because there's no auto-redirect, so the user must click "Reload" in the flag to continue.
        if (converterWasCurrentUser) // Manually set a timeout so the flag auto-closes after the page transition completes.
        setTimeout(()=>flags.hideFlag(successFlag.id), $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME);
    }, [
        intl,
        flags,
        handleOnClick
    ]);
};
module.exports["useShowConvertToLivePageFlag"] = $a23dc1f066cda204$export$cb5a789d90de377;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $T1bCI.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("8WQTF", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    rendererActions: null,
    pageId: undefined,
    pageAdf: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRendererActions: ()=>{},
    setPageAdf: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $42omo.useState)(null);
    const [pageId, setPageId] = (0, $42omo.useState)(undefined);
    const [pageAdf, setPageAdf] = (0, $42omo.useState)(undefined);
    const providerValue = (0, $42omo.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId,
            pageAdf: pageAdf
        }), [
        rendererActions,
        pageId,
        pageAdf
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            },
            setPageAdf: (newPageAdf)=>{
                setPageAdf(newPageAdf);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $42omo.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $42omo.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});

parcelRegister("Asv1P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $fTXBo = parcelRequire("fTXBo");

const $040545af9856ecf6$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const methodRef = (0, $fTXBo.useTrackedRef)(method);
    const payloadRef = (0, $fTXBo.useTrackedRef)(payload);
    return (0, $42omo.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};
module.exports["useCallbackWithAnalytics"] = $040545af9856ecf6$export$53c2b9c37c40e0d8;

});

parcelRegister("kDhla", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $9zUhf.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $9zUhf.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $9zUhf.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bYUc2 = parcelRequire("bYUc2");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    const isNav4Enabled = (0, $bYUc2.getIsNav4EnabledSafe)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: isNav4Enabled,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("2n4E1"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("2n4E1"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("2n4E1", function(module, exports) {

let $1ba1550d91d292e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ba1550d91d292e8$var$load("1iUSs"),
    $1ba1550d91d292e8$var$load("8ublV"),
    $1ba1550d91d292e8$var$load("iBFHX"),
    $1ba1550d91d292e8$var$load("jXx9i"),
    $1ba1550d91d292e8$var$load("nbjnv"),
    $1ba1550d91d292e8$var$load("9ftJe"),
    $1ba1550d91d292e8$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("hHZWk", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $42omo.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
const $fe7178b75f06350f$export$b688bc1b9fd324b6 = (0, $3u0dr.isReactCompilerActiveV1)() ? function MarkPlaceholderIgnoredWrapper(t0) {
    const $ = (0, $frIzR.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function MarkPlaceholderIgnoredWrapper({ placeholder: placeholder, children: children }) {
    (0, $42omo.useLayoutEffect)(()=>{
        const markPlaceholderIgnored = (e)=>{
            if (e?.tagName === 'SPAN') {
                e.setAttribute('data-ssr-placeholder-ignored', 'true');
                Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
            }
        };
        markPlaceholderIgnored(placeholder);
    }, [
        placeholder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("euF5O", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $914eacf4cf3bd652$export$26c05f52dcf7c5f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    shouldRefetchMacroQuery: false
});
module.exports["LegacyMacroRendererContext"] = $914eacf4cf3bd652$export$26c05f52dcf7c5f2;

});

parcelRegister("83Z6R", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

function $b847dc1d37d68706$export$dcf9d4e77de27956(...[query, params]) {
    const resolversRef = (0, $42omo.useRef)();
    /**
	 * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
	 */ const [doQuery, { data: data, error: error }] = (0, $jxs8y.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        params
    ]);
    (0, $42omo.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $42omo.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
}
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("hpRYU", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $gtD4K = parcelRequire("gtD4K");


var $kSKAi = parcelRequire("kSKAi");


var $7rus4 = parcelRequire("7rus4");


var $6f0Oj = parcelRequire("6f0Oj");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $7lu50 = parcelRequire("7lu50");


var $7Sm4c = parcelRequire("7Sm4c");


var $83Z6R = parcelRequire("83Z6R");


var $6mKj3 = parcelRequire("6mKj3");


var $jjoF2 = parcelRequire("jjoF2");


var $6RGMW = parcelRequire("6RGMW");


var $g3p2i = parcelRequire("g3p2i");

const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
const $4cbf051190fe8573$var$DefaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, children);
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, displayEmailInByline: displayEmailInByline, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId, isClearable: isClearable = true, includeUsers: includeUsers = true, transformOptions: transformOptions, userResolvers: userResolvers, components: components })=>{
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const queryUserAndGroupSearch = (0, $83Z6R.useLazyQueryPromiseInterop)((0, $6RGMW.UserAndGroupSearchQuery));
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}`);
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError);
            // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            queryData: queryUserAndGroupSearch({
                variables: {
                    withGroups: includeGroup,
                    searchTerm: searchTerm,
                    sitePermissionTypeFilter: sitePermissionTypeFilter,
                    withUsers: withUsers
                }
            }),
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.search.error",
        defaultMessage: "Sorry, we\u2019re having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.permission.error",
        defaultMessage: "We couldn\u2019t find any results because you don't have permission to search the user directory."
    });
    // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.and.groups",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name"
    }));
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        displayEmailInByline: displayEmailInByline,
        allowEmail: allowEmail,
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: enableEmailSearch,
        allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        components: components,
        withUsers: // Type assertion: runtime receives Option, but UserPicker types expect OptionData
        withUsers,
        header: header,
        open: open,
        'aria-labelledby': `react-select-${fieldId}-placeholder`,
        'aria-describedby': userpickerDescribedbyId,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        // bug with UserPicker forces us to use a callback rather than just pass in a string
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance,
        isClearable: isClearable
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rus4.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        includeUsers: includeUsers,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context" // infer principal ID from UCT
        ,
        productKey: "confluence",
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        includeTeamsUpdates: includeTeamsUpdates,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        isClearable: isClearable,
        transformOptions: transformOptions,
        userResolvers: userResolvers,
        displayEmailInByline: (0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false),
        enableEmailSearch: (0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false),
        allowEmailSelectionWhenEmailMatched: !(0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false)
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = $4cbf051190fe8573$export$fd4159eb872f73c6;
module.exports["UserAndGroupSearchPicker"] = $4cbf051190fe8573$export$ca514d5352bb0171;

});

parcelRegister("jjoF2", function(module, exports) {

var $9fywD = parcelRequire("9fywD");


var $11dKl = parcelRequire("11dKl");


var $9eE57 = parcelRequire("9eE57");


var $g3p2i = parcelRequire("g3p2i");

const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, queryData: queryData, customInclusion: customInclusion, setError: setError, filterResults: filterResults })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return queryData.then((data)=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch ?? {};
        const userList = users.map((item)=>({
                id: `user-${item && 'accountId' in item ? item.accountId : ''}`,
                name: item?.displayName || '',
                extra: item,
                type: 'user',
                avatarUrl: item?.profilePicture ? item.profilePicture.path : '',
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item?.id}`,
                name: item?.name || '',
                type: 'group',
                extra: item,
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().includes(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};
module.exports["userGroupSearchPromise"] = $9d3a4572140e810a$export$c139484855007019;

});

parcelRegister("11dKl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $f9006b515271a00f$var$i18n = (0, $cgtv4.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalGroupLozengeProps"] = $f9006b515271a00f$export$fef38ba78dbe85a6;

});

parcelRegister("g3p2i", function(module, exports) {
/**
 * @generated SignedSource<<40e2b37836ef7625e634b9236789b118>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});
module.exports["SitePermissionType"] = $fc6a2e7c662c45f6$export$8995abb8169b2cb8;
module.exports["SitePermissionTypeFilter"] = $fc6a2e7c662c45f6$export$3347a7c058a0368a;

});

parcelRegister("6RGMW", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $88fbd0e78227b736$export$9eed0d08b5194ae7 = (0, $eSUdr.default)`query UserAndGroupSearchQuery($searchTerm:String!$maxResults:Int=50$withGroups:Boolean=true$withUsers:Boolean=true$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm maxResults:$maxResults sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){type displayName permissionType profilePicture{path}...on KnownUser{accountId}}groups@include(if:$withGroups){id name permissionType}}}`;
module.exports["UserAndGroupSearchQuery"] = $88fbd0e78227b736$export$9eed0d08b5194ae7;

});

parcelRegister("iquRY", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            variables: {
                cloudId: cloudId
            },
            onError: $cccaa992351fdb79$var$_temp
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), t0);
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t1 = data?.confluence_spaceRoleMode;
    let t2;
    if ($[2] !== isNotPreRoles || $[3] !== loading || $[4] !== t1) {
        t2 = {
            spaceRoleMode: t1,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[2] = isNotPreRoles;
        $[3] = loading;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        variables: {
            cloudId: cloudId
        },
        onError: (error)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== 'PRE_ROLES' : false;
    return {
        spaceRoleMode: data?.confluence_spaceRoleMode,
        isRbacEnabled: isNotPreRoles,
        loading: loading
    };
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<fca40edcd431a6c5f3bb28df1ad0109c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("i28ZW", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $42omo = parcelRequire("42omo");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $eSUdr.default)`query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id currentUser{isAdmin}operations{operation targetType}}}`;
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled;
    const { data: data, loading: loading } = (0, $xQxzY.useQuery)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        }
    });
    const hasSpaceOperation = (0, $42omo.useCallback)((spaceOperation)=>{
        return data?.space?.operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
    }, [
        data
    ]);
    return {
        canManageSomeUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4) || hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149) || hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: hasSpaceOperation($981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: hasSpaceOperation($981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: hasSpaceOperation($981a614bc39b93a3$export$a89133b28496ff30),
        canAdminister: hasSpaceOperation($981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: hasSpaceOperation($981a614bc39b93a3$export$50faaafd42078ad9),
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("erzVD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0c6da6b618ff535$export$44ec82a0a8c60a0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xpRfQ",
    name: "InspectPermissionsDialog",
    loader: async ()=>(await (parcelRequire("1gUU3"))).InspectPermissionsDialog
});
module.exports["InspectPermissionsDialog"] = $d0c6da6b618ff535$export$44ec82a0a8c60a0e;

});

parcelRegister("1gUU3", function(module, exports) {

let $0ed36cd6a80d4c6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0ed36cd6a80d4c6d$var$load("kWZnd"),
    $0ed36cd6a80d4c6d$var$load("92LGf"),
    $0ed36cd6a80d4c6d$var$load("6wr18"),
    $0ed36cd6a80d4c6d$var$load("dMOc8"),
    $0ed36cd6a80d4c6d$var$load("aX0L0"),
    $0ed36cd6a80d4c6d$var$load("QcHuP"),
    $0ed36cd6a80d4c6d$var$load("iQ0Jm"),
    $0ed36cd6a80d4c6d$var$load("ev7SX"),
    $0ed36cd6a80d4c6d$var$load("ijPJo"),
    $0ed36cd6a80d4c6d$var$load("k8XPW"),
    $0ed36cd6a80d4c6d$var$load("fWCRm"),
    $0ed36cd6a80d4c6d$var$load("Wowvf"),
    $0ed36cd6a80d4c6d$var$load("dTsOE"),
    $0ed36cd6a80d4c6d$var$load("kHOMt"),
    $0ed36cd6a80d4c6d$var$load("hhss7"),
    $0ed36cd6a80d4c6d$var$load("ffEVr"),
    $0ed36cd6a80d4c6d$var$load("85liN")
]).then(()=>parcelRequire('jl66H'));

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("3oWMY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $goxV5 = parcelRequire("goxV5");


const $aac74fc16bd2f0e9$export$60620c3d63f5f30 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tETtx",
    name: "RendererPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("3Cqmt"))).RendererPageCoverPicture;
    },
    loading: (0, $goxV5.RendererPageCoverPicturePlaceholder)
});
module.exports["RendererPageCoverPicture"] = $aac74fc16bd2f0e9$export$60620c3d63f5f30;

});

parcelRegister("goxV5", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jVylI = parcelRequire("jVylI");


var $9wGTI = parcelRequire("9wGTI");

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/use-tokens-space, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766 */ const $be005db184746995$var$Placeholder = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFixedWidthImageOption: isFixedWidthImageOption, isObjectHeaderEnabled: isObjectHeaderEnabled, isPagePreview: isPagePreview, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_bfhki8nm",
            __cmplp.isFixedWidthImageOption ? "_19pkidpf _2hwx1wug _otyridpf _18u01wug _19pk14id _1bsb1c3h" : "_19pk14id _1bsb14oa _18u09b24",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isPagePreview || __cmplp.isSpaceOverview && __cmplp.hasEmoji ? "_otyrpxbi" : "_otyrxy5q",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedWidthImageOption: isFixedWidthImageOption, isObjectHeaderEnabled: isObjectHeaderEnabled, isPagePreview: isPagePreview, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bfhki8nm",
            __cmplp.isFixedWidthImageOption ? "_19pkidpf _2hwx1wug _otyridpf _18u01wug _19pk14id _1bsb1c3h" : "_19pk14id _1bsb14oa _18u09b24",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isPagePreview || __cmplp.isSpaceOverview && __cmplp.hasEmoji ? "_otyrpxbi" : "_otyrxy5q",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
            __cmplp.className
        ])
    });
});
const $be005db184746995$export$e9417b149b0db09d = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { coverPicture: coverPicture, isPagePreview: isPagePreview, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, coverPictureWidthOverride: coverPictureWidthOverride } = t0;
    const hasCoverPicture = isPagePreview ? !!coverPicture?.draft?.value?.id : !!coverPicture?.published?.value?.id;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const isFixedWidthImageOption = coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    let t1;
    if ($[0] !== appearance || $[1] !== hasCoverPicture || $[2] !== hasEmoji || $[3] !== isFixedWidthImageOption || $[4] !== isPagePreview || $[5] !== isSpaceOverview) {
        t1 = hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($be005db184746995$var$Placeholder, {
            contentAppearance: appearance,
            isPagePreview: isPagePreview,
            isSpaceOverview: isSpaceOverview,
            hasEmoji: hasEmoji,
            isFixedWidthImageOption: isFixedWidthImageOption,
            isObjectHeaderEnabled: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
        })) : null;
        $[0] = appearance;
        $[1] = hasCoverPicture;
        $[2] = hasEmoji;
        $[3] = isFixedWidthImageOption;
        $[4] = isPagePreview;
        $[5] = isSpaceOverview;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ coverPicture: coverPicture, isPagePreview: isPagePreview, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, coverPictureWidthOverride: coverPictureWidthOverride })=>{
    const hasCoverPicture = isPagePreview ? !!coverPicture?.draft?.value?.id : !!coverPicture?.published?.value?.id;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const isFixedWidthImageOption = coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    return hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($be005db184746995$var$Placeholder, {
        contentAppearance: appearance,
        isPagePreview: isPagePreview,
        isSpaceOverview: isSpaceOverview,
        hasEmoji: hasEmoji,
        isFixedWidthImageOption: isFixedWidthImageOption,
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
    })) : null;
};
module.exports["RendererPageCoverPicturePlaceholder"] = $be005db184746995$export$e9417b149b0db09d;

});

parcelRegister("3Cqmt", function(module, exports) {

let $2a295e8f7cdb8984$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2a295e8f7cdb8984$var$load("jSdjl"),
    $2a295e8f7cdb8984$var$load("l2EUC"),
    $2a295e8f7cdb8984$var$load("zjNVa"),
    $2a295e8f7cdb8984$var$load("f35QR"),
    $2a295e8f7cdb8984$var$load("eVYW1"),
    $2a295e8f7cdb8984$var$load("ls0Um"),
    $2a295e8f7cdb8984$var$load("020xd"),
    $2a295e8f7cdb8984$var$load("eTBsW"),
    $2a295e8f7cdb8984$var$load("bYxCZ"),
    $2a295e8f7cdb8984$var$load("6HBYC"),
    $2a295e8f7cdb8984$var$load("eDqo1"),
    $2a295e8f7cdb8984$var$load("lxiFd"),
    $2a295e8f7cdb8984$var$load("1oiJ6"),
    $2a295e8f7cdb8984$var$load("huUvS"),
    $2a295e8f7cdb8984$var$load("6wr18"),
    $2a295e8f7cdb8984$var$load("ht6hk"),
    $2a295e8f7cdb8984$var$load("6vhrJ"),
    $2a295e8f7cdb8984$var$load("ffEVr"),
    $2a295e8f7cdb8984$var$load("jXx9i"),
    $2a295e8f7cdb8984$var$load("6iKyY"),
    $2a295e8f7cdb8984$var$load("9iZkh"),
    $2a295e8f7cdb8984$var$load("4Bg7q")
]).then(()=>parcelRequire('9ChZM'));

});


//# sourceMappingURL=ContentTools.49529a81.js.map
